// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T21:52:07.647Z
// Property: Cedar Wood Apartments (ID: 6767906449167350)
// Collections: 29 amenities, 4 floorplans (live), 16 photos, 81 POIs, 1 reviews, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162458",
  "multihub_property_id": "6767906449167350",
  "property_external_id": "5098666",
  "property_zillow_url": "https://www.zillow.com/b/cedar-woods-apartments-mansfield-oh-5XnPMP/",
  "property_apartments_url": "https://www.apartments.com/cedar-wood-apartments-mansfield-oh/01tw4f3/",
  "property_google_business_url": "https://www.google.com/maps/place/Cedar+Wood+Apartments/data=!4m2!3m1!1s0x0:0x7c7de8f953650df4?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "57762357110",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "5098666",
  "property_status": null,
  "property_slug": "cedar-wood-apartments",
  "property_name": "Cedar Wood Apartments",
  "property_website_url": "https://www.cedarwoodapartmentliving.com/",
  "property_domain": "https://www.cedarwoodapartmentliving.com/",
  "property_address": "478 E Cook Rd",
  "property_full_address": "478 E Cook Rd, Mansfield, OH 44903",
  "property_address_1": "478 E Cook Rd",
  "property_address_2": null,
  "property_address_city": "Mansfield",
  "property_address_state": "OH",
  "property_address_zip_full": "44903-6706",
  "property_address_zip": "44903",
  "property_address_country": "US",
  "property_address_county": "Richland County",
  "property_neighborhood_address": "Mansfield",
  "property_address_latitude": "40.7310335",
  "property_address_longitude": "-82.4972715",
  "property_email": "cwa@dietzpropertygroup.com",
  "property_phone": "(419) 522-4750",
  "property_call_tracking_phone": "419-522-4750",
  "property_company_name": "Dietz Property Group",
  "property_company_url": "https://dietzpropertygroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Cedar Wood Apartments in Mansfield, OH, we offer spacious two and three-bedroom floor plans designed for modern living. Enjoy pet-friendly amenities, professional management, and the comfort of central heat and air conditioning. Experience an ideal location with flexible rent payment options. Find your new home today—explore our availability or schedule a tour!",
  "property_long_description": "Welcome to Cedar Wood Apartments, where modern living meets comfort in the heart of Mansfield, OH. Our thoughtfully designed community offers spacious two-bedroom and three-bedroom floor plans, perfect for families, roommates, or anyone seeking extra space. Each apartment features essential amenities like central heating and air conditioning, ensuring a cozy environment year-round. \n\nCedar Wood Apartments is not just a place to live; it's a community that welcomes pets, making it the ideal choice for animal lovers. Our professional management team is dedicated to providing excellent service, ensuring that your living experience is seamless and enjoyable. With flexible rent payments available, we strive to accommodate your financial needs and help you feel at home.\n\nNestled in an ideal location, Cedar Wood offers convenient access to local attractions, shopping, and dining, making it easy to explore everything Mansfield has to offer. Whether you choose our 2 Bedroom Tier 1 or one of our expansive three-bedroom units, you'll find ample space and modern finishes that elevate your living experience.\n\nDon't miss out on the opportunity to call Cedar Wood Apartments home! Find your new home today—browse our availability or schedule a tour to visit our community. Discover the perfect blend of comfort, convenience, and community at Cedar Wood Apartments!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
    "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
    "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
    "width": 2047,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "96",
  "property_year_built": "2000",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.70833333333334",
  "property_admin_fee": "150",
  "property_application_fee": "25",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs up to 2 pets per apartment home. Breed restrictions apply.",
  "property_pet_policy_description": "Cedar Wood Apartments is a pet friendly community. We proudly accept cats and dogs, up to 2 pets per apartment home. There is a non‑refundable pet fee of $200 per pet (up to $400 total) and a monthly pet rent of $35 per pet (ranging $35–$70 total). Breed restrictions apply.",
  "property_petpolicy_info": "Pet Policy Type: Cat, Dogs\nPet Monthly Rent Min/Max: $35 - $70\nPet Policy: Cedar Wood Apartments is a pet friendly community. We proudly accept up to 2 pets per apartment home. There is a non-refundable pet fee of $200 per pet and a monthly pet rent of $35 per pet. Please contact our Leasing Office for our full pet policy. Breed restrictions apply.\nPet Rent Basis: Per Pet\nMax Number of Pets: 2\nPet Policy Fee Min/Max: $200 - $400",
  "property_online_leasing_url": "https://8966422.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://cedarwoodapts.loftliving.com/login",
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63af-d562-76fb-bbf3-f474733064f4.webp",
  "property_primary_logo_media": {
    "alt_text": "Cedar Wood Apartments logo",
    "public_id": "019d63af-d562-76fb-bbf3-f474733064f4",
    "storage_key": "property/6767906449167350/019d63af-d562-76fb-bbf3-f474733064f4.webp",
    "width": 600,
    "height": 231
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63af-d5be-725d-8228-9df09ecd9420.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cedar Wood Apartments logo",
    "public_id": "019d63af-d5be-725d-8228-9df09ecd9420",
    "storage_key": "property/6767906449167350/019d63af-d5be-725d-8228-9df09ecd9420.webp",
    "width": 600,
    "height": 231
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b0-18f5-7263-8640-87792b610b0d.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019d63b0-18f5-7263-8640-87792b610b0d",
    "storage_key": "property/6767906449167350/019d63b0-18f5-7263-8640-87792b610b0d.webp",
    "width": 600,
    "height": 231
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
  "property_company_logo_media": {
    "alt_text": "Dietz Property Group logo",
    "public_id": "019d638a-0da7-727f-ad43-3bd78629f61b",
    "storage_key": "company/5767906449162458/019d638a-0da7-727f-ad43-3bd78629f61b.webp",
    "width": 992,
    "height": 329
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "DPG logo",
    "public_id": "019e28a2-379b-72ca-a5a9-1262d569a77e",
    "storage_key": "company/5767906449162458/019e28a2-379b-72ca-a5a9-1262d569a77e.webp",
    "width": 344,
    "height": 329
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "DPG logo in white on black background.",
    "public_id": "019e28a2-7e6e-752b-a7e2-54f21a5cd171",
    "storage_key": "company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp",
    "width": 344,
    "height": 329
  },
  "property_primary_color": "#f0845f",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#000000",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 3",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "851 - 1001",
  "property_sqft_min": "851",
  "property_sqft_max": "1001",
  "property_price_range": "826 - 1119",
  "property_price_min": "826",
  "property_price_max": "1119",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/wedgewoodseniorliving/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJKfZeAxjqOYgR9A1lU_nofXw",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Apartments&find_loc=Lexington%2C+OH",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cedar Wood Apartments",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Home Today",
  "property_home_amenities_blurb": "Welcome to Cedar Wood Apartments in Mansfield, OH, where comfort meets convenience. Choose from our spacious two and three-bedroom floor plans, designed with you in mind. Enjoy pet-friendly living, professional management, and flexible rent options, all in an ideal location. Experience the harmonious balance of home and community today!",
  "property_home_floorplans_blurb": "At Cedar Wood Apartments in Mansfield, OH, your ideal living space awaits. Choose from spacious two and three-bedroom floor plans designed for comfort and style. Embrace a vibrant community atmosphere while enjoying modern amenities. Browse our available apartment homes and find your perfect sanctuary today!",
  "property_home_gallery_blurb": "At Cedar Wood Apartments in Mansfield, OH, envision a life of comfort with our spacious two and three-bedroom floor plans. Enjoy pet-friendly living, professional management, and flexible rent options. With central heating, air conditioning, and a prime location, your perfect home awaits. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Cedar Wood Apartments in Mansfield, OH, where spacious two- and three-bedroom floor plans meet vibrant community life. Just minutes away, explore Gorman Nature Center's trails, enjoy the rich history at the Ohio State Reformatory, or hike through Kingwood Center Gardens. Engage with the local culture and activities that enrich your lifestyle!",
  "property_home_reviews_blurb": "At Cedar Wood Apartments in Mansfield, OH, residents enjoy a well-maintained, secure community, with a glowing 5.0 rating. Experience the comfort of our locked building and hear what our residents love: “Nice place.” Join a community where every detail matters and see what our residents have to say!",
  "property_neighborhood_blurb": "Welcome to Cedar Wood Apartments, where vibrant community life meets serene living in Mansfield, OH. Nestled near parks, schools, and cultural attractions like the Renaissance Theatre and Kingwood Center Gardens, our two- and three-bedroom homes offer the perfect blend of comfort and convenience. Experience local charm today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cedar Wood Apartments in Mansfield, OH, enjoy spacious two and three-bedroom layouts designed for comfort and convenience. Our pet-friendly community boasts professional management and flexible rent payments, complemented by modern amenities like central heating and air conditioning. Uncover the lifestyle you deserve—your perfect home awaits!",
  "property_applynow_blurb": "At Cedar Wood Apartments in Mansfield, OH, our spacious two- and three-bedroom floor plans accommodate your lifestyle. Enjoy pet-friendly living, professional management, and the comfort of central heat and air. Embrace convenience with flexible rent payments. Find your perfect home and lease online today!",
  "property_contactus_blurb": "At Cedar Wood Apartments in Mansfield, OH, our thoughtfully designed two-bedroom and three-bedroom floor plans offer comfort and style for every lifestyle. Whether you're seeking spacious living or cozy rooms, we have the perfect layout for you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At Cedar Wood Apartments in Mansfield, OH, find your perfect home with our spacious two and three-bedroom floor plans. We value your questions and invite you to browse our FAQs page for insights into community living, amenities, and more. Your ideal apartment experience starts here!",
  "property_floorplans_blurb": "At Cedar Wood Apartments in Mansfield, OH, style meets comfort in our thoughtfully designed two and three-bedroom homes. Each layout maximizes space and light, ensuring a cozy haven for you and your loved ones. Browse our available options today and imagine the life waiting for you at Cedar Wood.",
  "property_gallery_blurb": "At Cedar Wood Apartments in Mansfield, OH, vibrant two and three-bedroom layouts cater to every lifestyle. With pet-friendly amenities, modern comforts like central heat and air conditioning, and professional management, your ideal home awaits. Picture yourself living here—browse our captivating photo gallery and envision your future!",
  "property_interactivemap_blurb": "At Cedar Wood Apartments in Mansfield, OH, find the ideal living space tailored to your needs, from cozy two-bedroom layouts to spacious three-bedroom options. Embrace a pet-friendly lifestyle with professional management and modern amenities. Utilize our interactive community map to uncover availability and define your perfect home today!",
  "property_pets_blurb": "At Cedar Wood Apartments in Mansfield, OH, your furry friends are part of the family. Revel in our pet-friendly community, where cats and dogs thrive together. With ample amenities and green spaces, you and your pets can enjoy the perfect blend of comfort and play in your new home.",
  "property_referafriend_blurb": "At Cedar Wood Apartments in Mansfield, OH, your ideal living space awaits with spacious two and three-bedroom floor plans tailored for comfort. Embrace a vibrant community where great friends become great neighbors. Share the joy of home—refer a friend today and make memories that last a lifetime!",
  "property_residentaccess_blurb": "At Cedar Wood Apartments in Mansfield, OH, your ideal home awaits with spacious two and three-bedroom floor plans designed for comfort and style. Elevate your living experience—access your resident portal today to effortlessly manage rent, maintenance requests, and more. Enjoy the convenience of modern apartment living!",
  "property_reviews_blurb": "At Cedar Wood Apartments in Mansfield, OH, our residents cherish a well-maintained, secure environment that boasts a perfect 5.0 rating. One resident praises our “locked building” feature, ensuring peace of mind. See what our residents have to say about living at our community and join the Cedar Wood experience!",
  "property_created_at": "1775493899036",
  "property_scheduletour_blurb": "At Cedar Wood Apartments in Mansfield, OH, spacious two and three-bedroom floor plans await you. Envision your life here, surrounded by vibrant community vibes and lush landscapes. Curious about real experiences? Hear firsthand from our residents about why they love calling Cedar Wood home! Schedule a tour today!",
  "property_thankyou_blurb": "Thank you for reaching out to Cedar Wood Apartments in Mansfield, OH! Our spacious two and three-bedroom floor plans are designed with your comfort in mind. Stay tuned; our team will connect with you soon to guide you through finding your perfect new home. Your ideal lifestyle awaits!",
  "property_virtualtours_blurb": "At Cedar Wood Apartments in Mansfield, OH, experience spacious living with thoughtfully designed two and three-bedroom floor plans tailored for comfort. Immerse yourself in our vibrant community and take a virtual tour today to envision your future home, where convenience and community come together in perfect harmony.",
  "property_copyright": "2026 All Rights Reserved. Cedar Wood Apartments",
  "property_seo_title_home": "Affordable Apartments in Mansfield, OH | Cedar Wood",
  "property_seo_description_home": "Explore affordable two- and three-bedroom apartments in Mansfield, OH at Cedar Wood. Income restrictions apply. View floor plans and qualification details.",
  "property_seo_title_floorplans": "Affordable 2 & 3 Bedroom Apts in Mansfield, OH | Floor Plans",
  "property_seo_description_floorplans": "View affordable two- and three-bedroom apartments in Mansfield, OH at Cedar Wood. Income restrictions apply. Explore available floor plans.",
  "property_seo_title_amenities": "Amenities | Mansfield, OH Apartments for Rent",
  "property_seo_description_amenities": "Experience comfort at Cedar Wood Apartments in Mansfield, OH. Enjoy pet-friendly living, flexible rent, and welcoming amenities for a vibrant lifestyle.",
  "property_seo_title_gallery": "Gallery | Apartments in Mansfield, OH",
  "property_seo_description_gallery": "Discover pet-friendly Cedar Wood Apartments in Mansfield, OH, featuring flexible rent and great amenities. Explore your new life in our photo gallery!",
  "property_seo_title_virtualtours": "Virtual Tours | Cedar Wood Apartments Apartments",
  "property_seo_description_virtualtours": "Experience Cedar Wood Apartments in Mansfield, OH! Take a virtual tour to explore our spacious two and three-bedroom layouts and find your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Cedar Wood Apartments Apartments",
  "property_seo_description_interactivemap": "Discover Cedar Wood Apartments in Mansfield, OH! Choose from spacious two and three-bedroom layouts with pet-friendly amenities and flexible rent.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Mansfield, OH",
  "property_seo_description_neighborhood": "Uncover the charm of Mansfield, OH at Cedar Wood Apartments! From cozy cafes to parks, dive into local favorites just steps from your new home.",
  "property_seo_title_contact": "Contact Us | Cedar Wood Apartments",
  "property_seo_description_contact": "Reach out to Cedar Wood Apartments in Mansfield, OH! Explore our spacious two and three-bedroom floor plans. We're here to help with your leasing questions!",
  "property_seo_title_faqs": "FAQs | Apartments in Mansfield, OH",
  "property_seo_description_faqs": "Curious about Cedar Wood Apartments in Mansfield, OH? Our FAQs cover pet policies, flexible rent, and more. Get the answers you need today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Mansfield, OH",
  "property_seo_description_reviews": "Discover Cedar Wood Apartments in Mansfield, OH! Read resident reviews and see why our pet-friendly community with flexible payments feels like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Mansfield, OH",
  "property_seo_description_applynow": "Discover Cedar Wood Apartments in Mansfield, OH! Enjoy pet-friendly options, spacious layouts, and flexible leasing. Your perfect home awaits!",
  "property_seo_title_residentaccess": "Resident Access | Cedar Wood Apartments",
  "property_seo_description_residentaccess": "Log in to Cedar Wood Apartments' resident portal for hassle-free rent payments, maintenance requests, and community updates—all from the comfort of home!",
  "property_seo_title_referafriend": "Refer A Friend | Cedar Wood Apartments",
  "property_seo_description_referafriend": "Refer a friend to Cedar Wood Apartments in Mansfield, OH! Great friends make great neighbors—share the joy of living in our welcoming community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cedar Wood Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Cedar Wood Apartments in Mansfield, OH. Schedule your tour today and envision your new life in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Cedar Wood Apartments",
  "property_seo_description_privacy": "Your privacy matters at Cedar Wood Apartments in Mansfield, OH. Review our policies to see how we safeguard your personal information. Read more now!",
  "property_seo_title_accessibility": "Website Accessibility | Cedar Wood Apartments",
  "property_seo_description_accessibility": "At Cedar Wood Apartments, Mansfield, OH, we prioritize accessibility for all, fostering a community where everyone thrives and enjoys digital inclusion.",
  "property_seo_title_sitemap": "Sitemap | Cedar Wood Apartments",
  "property_seo_description_sitemap": "Uncover a world of convenience at Cedar Wood Apartments in Mansfield, OH. Check our sitemap to find your perfect home today—comfort awaits you!",
  "property_seo_title_thankyou": "Thank You | Cedar Wood Apartments",
  "property_seo_description_thankyou": "Thank you for your interest in Cedar Wood Apartments in Mansfield, OH! Our team will reach out soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Mansfield, OH",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790198949512",
  "amenities": [
    {
      "id": "ec_b40e83b760064eac3ff4c72b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0da7430b3342e5fef09631c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9832b5b676ae1a51e33d941",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Maintenance on site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c351b9fdc5039f148a895d4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d842b5f3526b1b714be497cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "2 Bedroom Tier 1",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48ae6e9089f1d7307a8a2a58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony / Patio",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8773246aa05d3cefc55a43de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Central Heat & Air Conditionin",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8dda095ad81b69d17aff0bf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Flexible Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_65927aa1c0be8b17f10b2177",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e69f3bd0e68a179c0b328eee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Nearby Shopping and Entertainment",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4f8eba0b461e9d2627d34125",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ccb2e39fca0511c39e0c9f8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_50846620ff1730f0ae7561f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5665f221810c0c92d2d96bf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ee89f378040ca99060d0ee3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_673dbc9b3326cfc4a6d8b437",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_932e99f1f071f10d547f2d72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48c3333cc8064fb6f9836f83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_169bdcd1583ea9ac92037b65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c50aa1e68d529de1029c7761",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4316c8b9403af94ec18d5996",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ce95ff40ab7ff712b199cf5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Tile Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_139588ea75e92baf32813b79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e1f2ed969527c568fa1f75f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Carpet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_076fa37fac1a718a5f18e39d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e230946c71610ccc03ca71a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Office",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d78263582901f65362402f71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Vinyl Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_384ec7a84154296ac1c35d13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e3cca71823ee7da0d687974",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "apartments",
      "external_id": "false",
      "title": "Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_0d032d8a-4606-4a4d-a8ea-f2be67158229",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a08756-a76f-73ae-aba3-cf8c0b6eee50.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in an apartment, featuring a round table with chairs and a stove.",
        "public_id": "01a08756-a76f-73ae-aba3-cf8c0b6eee50",
        "storage_key": "property/6767906449167350/01a08756-a76f-73ae-aba3-cf8c0b6eee50.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals in this cozy dining area, adjacent to a well-equipped kitchen with a stove and ample cabinet space.",
      "link": "",
      "alt_text": "Dining area and kitchen in an apartment, featuring a round table with chairs and a stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_85586256-9737-4ad8-8d8a-00771638aaa7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a01564-f37f-727f-bc9e-3c4bbb6e0136.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances including a stove, refrigerator, and sink.",
        "public_id": "01a01564-f37f-727f-bc9e-3c4bbb6e0136",
        "storage_key": "property/6767906449167350/01a01564-f37f-727f-bc9e-3c4bbb6e0136.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This kitchen features white appliances, ample cabinet space, and a view into an adjacent area.",
      "link": "",
      "alt_text": "Kitchen with white appliances including a stove, refrigerator, and sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_165b9ff7-be32-4057-a9df-d9556247fb42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a08756-a7b8-752c-a1c1-86b53c744726.webp",
      "image_media": {
        "alt_text": "Living room and kitchen with TV, console, coffee table, and rug.",
        "public_id": "01a08756-a7b8-752c-a1c1-86b53c744726",
        "storage_key": "property/6767906449167350/01a08756-a7b8-752c-a1c1-86b53c744726.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with a mounted TV and a modern entertainment console, adjacent to a well-equipped kitchen. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen with TV, console, coffee table, and rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1e3dd976-f71a-4ffb-84c7-ef65f60ac63a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a08756-b3c2-76ee-89d9-8f69b9f4eb9e.webp",
      "image_media": {
        "alt_text": "Modern living room with a TV and entryway to bedroom.",
        "public_id": "01a08756-b3c2-76ee-89d9-8f69b9f4eb9e",
        "storage_key": "property/6767906449167350/01a08756-b3c2-76ee-89d9-8f69b9f4eb9e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a wall-mounted TV, stylish media console, and plush seating. Opens to a bedroom with a bed.",
      "link": "",
      "alt_text": "Modern living room with a TV and entryway to bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e9c14f6e-4d56-4602-9a6e-e21a30031d9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a08756-a8d5-7733-a60a-114dd2edff74.webp",
      "image_media": {
        "alt_text": "Bedroom with a large window and an en suite bathroom.",
        "public_id": "01a08756-a8d5-7733-a60a-114dd2edff74",
        "storage_key": "property/6767906449167350/01a08756-a8d5-7733-a60a-114dd2edff74.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A spacious bedroom featuring a large window with a view and access to an en suite bathroom.",
      "link": "",
      "alt_text": "Bedroom with a large window and an en suite bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_13fb568b-3f65-43f9-ae21-a05d0f13286c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a08756-a7ad-71ba-b465-8fa2e9127a4b.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed, neutral-toned walls, and a large window.",
        "public_id": "01a08756-a7ad-71ba-b465-8fa2e9127a4b",
        "storage_key": "property/6767906449167350/01a08756-a7ad-71ba-b465-8fa2e9127a4b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed bedroom, featuring a comfortable queen-size bed and ample natural light.",
      "link": "",
      "alt_text": "Stylish bedroom with a queen-size bed, neutral-toned walls, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ada15224-669a-4c72-817f-9a8811067d1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a08756-b352-76be-9c31-bf48893ac16b.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, closet, and adjacent bathroom entrance.",
        "public_id": "01a08756-b352-76be-9c31-bf48893ac16b",
        "storage_key": "property/6767906449167350/01a08756-b352-76be-9c31-bf48893ac16b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, ample closet space, and access to a nearby bathroom. A comfortable and inviting private retreat.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, closet, and adjacent bathroom entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_846e1519-1173-464a-bbc2-662faca09857",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a01565-56c3-70c9-9bf3-f9bb17370327.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, toilet, and bathtub with shower.",
        "public_id": "01a01565-56c3-70c9-9bf3-f9bb17370327",
        "storage_key": "property/6767906449167350/01a01565-56c3-70c9-9bf3-f9bb17370327.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this well-maintained bathroom featuring a clean vanity, a comfortable toilet, and a pristine bathtub with a shower.",
      "link": "",
      "alt_text": "Bathroom with a vanity, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dc1dce40-2330-436b-b4b0-1648131aeafd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a01565-1bc1-745f-b630-bc37371dd196.webp",
      "image_media": {
        "alt_text": "Clean bathroom with vanity, toilet, and bathtub with white tiled shower walls.",
        "public_id": "01a01565-1bc1-745f-b630-bc37371dd196",
        "storage_key": "property/6767906449167350/01a01565-1bc1-745f-b630-bc37371dd196.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a vanity with a sink, a toilet, and a bathtub/shower combination with classic white tiled walls.",
      "link": "",
      "alt_text": "Clean bathroom with vanity, toilet, and bathtub with white tiled shower walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5c150e12-f501-4e09-9654-f96159b41170",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a01565-0ffb-7227-a84d-173cabd918bb.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet and closet.",
        "public_id": "01a01565-0ffb-7227-a84d-173cabd918bb",
        "storage_key": "property/6767906449167350/01a01565-0ffb-7227-a84d-173cabd918bb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This image shows an empty bedroom with neutral-colored walls, gray carpet, and a sliding closet door.",
      "link": "",
      "alt_text": "Empty bedroom with carpet and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3e75db75-ec39-48bb-a5d5-2459aa3a4737",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a01564-ad87-76d7-b1fc-61110685062b.webp",
      "image_media": {
        "alt_text": "Exterior of a brick and vinyl apartment building with balconies and manicured lawn.",
        "public_id": "01a01564-ad87-76d7-b1fc-61110685062b",
        "storage_key": "property/6767906449167350/01a01564-ad87-76d7-b1fc-61110685062b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring a mix of brick and vinyl siding, private balconies, and lush green lawn. Offers a welcoming community atmosphere.",
      "link": "",
      "alt_text": "Exterior of a brick and vinyl apartment building with balconies and manicured lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bbe5c2f6-6f03-4277-a520-27e8b1154ec1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a01564-a951-73b7-8bb7-4c034a652713.webp",
      "image_media": {
        "alt_text": "Playground with swings and slides",
        "public_id": "01a01564-a951-73b7-8bb7-4c034a652713",
        "storage_key": "property/6767906449167350/01a01564-a951-73b7-8bb7-4c034a652713.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, complete with swings and slides for all ages.",
      "link": "",
      "alt_text": "Playground with swings and slides",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_42deea24-cbd9-4bbb-b2a1-f083f572a1fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a01564-ac7a-7384-97e0-58938eb86f49.webp",
      "image_media": {
        "alt_text": "Wooden staircase with carpeted steps.",
        "public_id": "01a01564-ac7a-7384-97e0-58938eb86f49",
        "storage_key": "property/6767906449167350/01a01564-ac7a-7384-97e0-58938eb86f49.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Ascend to new levels in this charming apartment community with beautifully maintained wooden staircases and carpeted steps.",
      "link": "",
      "alt_text": "Wooden staircase with carpeted steps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e733ab86-5853-4899-99af-0ec9a398dd28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a01564-888d-772a-9112-8fec348839cd.webp",
      "image_media": {
        "alt_text": "Exterior of the welcome center building with a parking lot in the foreground.",
        "public_id": "01a01564-888d-772a-9112-8fec348839cd",
        "storage_key": "property/6767906449167350/01a01564-888d-772a-9112-8fec348839cd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to the community! This is the exterior of our leasing office, the welcome center, where you can learn more about our amenities and available floor plans.",
      "link": "",
      "alt_text": "Exterior of the welcome center building with a parking lot in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_09998b90-b830-4622-99f2-27cb1a0c6bf5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a01564-888f-75c8-9b22-6396dff319f8.webp",
      "image_media": {
        "alt_text": "Mailbox kiosk with covered porch and parking",
        "public_id": "01a01564-888f-75c8-9b22-6396dff319f8",
        "storage_key": "property/6767906449167350/01a01564-888f-75c8-9b22-6396dff319f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient mail kiosk with individual mailboxes available for residents, located near parking and green spaces.",
      "link": "",
      "alt_text": "Mailbox kiosk with covered porch and parking",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_90128f8a-096d-43a8-97be-72b516f3c3f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/01a01564-8890-734d-9908-b2dccef7c23d.webp",
      "image_media": {
        "alt_text": "Cedar Wood Apartments monument sign",
        "public_id": "01a01564-8890-734d-9908-b2dccef7c23d",
        "storage_key": "property/6767906449167350/01a01564-8890-734d-9908-b2dccef7c23d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Cedar Wood Apartments. Experience comfortable living in our beautiful community.",
      "link": "",
      "alt_text": "Cedar Wood Apartments monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_5d10f5f11af6fab7a289bdbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Hudson & Essex",
      "poi_type": "Restaurants",
      "poi_address": "51 E 4th St, Mansfield, OH 44902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-6990-73f0-9d9e-27b3d6133b49.webp",
      "poi_featured_image_media": {
        "alt_text": "Display of snacks and gift items in a rustic setting",
        "public_id": "019dac40-6990-73f0-9d9e-27b3d6133b49",
        "storage_key": "property/6767906449167350/019dac40-6990-73f0-9d9e-27b3d6133b49.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://hudsonandessex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14920221277415560580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hudson--essex",
      "poi_latitude": "40.7611941",
      "poi_longitude": "-82.51369600000001",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 419-513-5151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019dac3e-74e9-7698-bcc8-fd1c4b58ca3f",
        "storage_key": "property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvxl1Q5frOYgRhFWUejNGD88",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "ec_c3ef7ab70e6fc2d7abbad61a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Coney Island Diner",
      "poi_type": "Restaurants",
      "poi_address": "98 N Main St, Mansfield, OH 44902, USA",
      "poi_short_description": "Casual eatery serving Coney Islands, burgers, fries, breakfast favorites and milkshakes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-68e5-762f-aa44-43cc6bc09669.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a charming ice cream parlor with neon signs and a red and white facade.",
        "public_id": "019dac40-68e5-762f-aa44-43cc6bc09669",
        "storage_key": "property/6767906449167350/019dac40-68e5-762f-aa44-43cc6bc09669.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.facebook.com/people/Coney-Island-Diner/100063575170325/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9780964982533160723&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coney-island-diner",
      "poi_latitude": "40.761184",
      "poi_longitude": "-82.5152043",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-526-2669",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019dac3e-74e9-7698-bcc8-fd1c4b58ca3f",
        "storage_key": "property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93Al0avrOYgRE39scNT3vIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "ec_552117ee915e4d229321edd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Relax, It’s Just Coffee",
      "poi_type": "Restaurants",
      "poi_address": "105 N Main St, Mansfield, OH 44902, USA",
      "poi_short_description": "Coffeehouse specializing in cappuccinos and lattes, plus a range of pastries and baked goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-85bb-77fd-9c94-cfb6b23ebe00.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Black Bird Bakery and Relax It's Just Coffee shop with outdoor seating and a character mascot.",
        "public_id": "019dac40-85bb-77fd-9c94-cfb6b23ebe00",
        "storage_key": "property/6767906449167350/019dac40-85bb-77fd-9c94-cfb6b23ebe00.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "http://www.relaxitsjustcoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9431443615018566227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "relax-its-just-coffee",
      "poi_latitude": "40.761339",
      "poi_longitude": "-82.51562330000002",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-709-8363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac41-0170-7299-8cdb-04e910642443.webp",
      "poi_map_icon_media": {
        "alt_text": "Coffee cup icon",
        "public_id": "019dac41-0170-7299-8cdb-04e910642443",
        "storage_key": "property/6767906449167350/019dac41-0170-7299-8cdb-04e910642443.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJdTln2VTqOYgRU8JOeP8344I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_b2768375fe4a5779bcba2b52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Athena Greek Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "41 N Main St, Mansfield, OH 44903, USA",
      "poi_short_description": "Simple, homey Greek eatery serving traditional platters, salads & pita sandwiches, plus pastries.",
      "poi_long_description": "Simple, homey Greek eatery serving traditional platters, salads & pita sandwiches, plus pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-6880-763b-a150-c19355a81984.webp",
      "poi_featured_image_media": {
        "alt_text": "Athena Greek Restaurant storefront with blue awning and potted flowers.",
        "public_id": "019dac40-6880-763b-a150-c19355a81984",
        "storage_key": "property/6767906449167350/019dac40-6880-763b-a150-c19355a81984.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.athenagreek.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11630190578955623685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "athena-greek-restaurant",
      "poi_latitude": "40.7595842",
      "poi_longitude": "-82.5157826",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-524-5620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019dac3e-74e9-7698-bcc8-fd1c4b58ca3f",
        "storage_key": "property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpRCOravrOYgRBZ2-ULa8ZqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "ec_a2625af693fb2b6570239291",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "UNCLE JOHN’S PLACE",
      "poi_type": "Restaurants",
      "poi_address": "18 S Main St, Mansfield, OH 44903, USA",
      "poi_short_description": "Low-key haunt dishing up creatively topped burgers, plus Reuben sandwiches, cheesesteaks & beer.",
      "poi_long_description": "Low-key haunt dishing up creatively topped burgers, plus Reuben sandwiches, cheesesteaks & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b6-d074-7199-9dbe-c1da2720317a.webp",
      "poi_featured_image_media": {
        "alt_text": "Neon sign for Uncle John's Place with red and blue lights.",
        "public_id": "019d63b6-d074-7199-9dbe-c1da2720317a",
        "storage_key": "property/6767906449167350/019d63b6-d074-7199-9dbe-c1da2720317a.webp",
        "width": 3072,
        "height": 1855
      },
      "poi_business_url": "https://m.facebook.com/pages/category/Bar---Grill/Uncle-Johns-Place-201497119878895/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8546188617002188573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uncle-johns-place",
      "poi_latitude": "40.7580399",
      "poi_longitude": "-82.5160046",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-526-9197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019dac3e-74e9-7698-bcc8-fd1c4b58ca3f",
        "storage_key": "property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ40SM4arrOYgRHf_me0QpmnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "ec_64cfd5fa379827779b61b889",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Rancho Fiesta",
      "poi_type": "Restaurants",
      "poi_address": "1360 S Trimble Rd, Mansfield, OH 44906, USA",
      "poi_short_description": "Casual, cheerful Mexican kitchen offering burritos, tacos & chimichangas, plus a full bar.",
      "poi_long_description": "Casual, cheerful Mexican kitchen offering burritos, tacos & chimichangas, plus a full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-9114-754b-a28d-c1ade521e53b.webp",
      "poi_featured_image_media": {
        "alt_text": "Rancho Fiesta Mexican Grill & Cantina exterior with outdoor seating.",
        "public_id": "019dbbf0-9114-754b-a28d-c1ade521e53b",
        "storage_key": "property/6767906449167350/019dbbf0-9114-754b-a28d-c1ade521e53b.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://ranchofiesta.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6661119539980582782&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rancho-fiesta",
      "poi_latitude": "40.7205217",
      "poi_longitude": "-82.5453653",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-774-1744",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019dac3e-74e9-7698-bcc8-fd1c4b58ca3f",
        "storage_key": "property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIW4r1qDqOYgRfr_08u0McVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_4d1a33f79ddd5064dac8268f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "The Golden Burrito",
      "poi_type": "Restaurants",
      "poi_address": "574 Park Ave E, Mansfield, OH 44905, USA",
      "poi_short_description": "Relaxed outlet for Mexican staples such as burritos, tacos and fried cheesecake.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-9483-7709-a5e2-65ed28c13895.webp",
      "poi_featured_image_media": {
        "alt_text": "The Golden Burrito Mexican Grill drive-thru menu board with a bright yellow building.",
        "public_id": "019dbbf0-9483-7709-a5e2-65ed28c13895",
        "storage_key": "property/6767906449167350/019dbbf0-9483-7709-a5e2-65ed28c13895.webp",
        "width": 3072,
        "height": 1382
      },
      "poi_business_url": "https://thegoldenburritooh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14391436769171236252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-golden-burrito",
      "poi_latitude": "40.7579459",
      "poi_longitude": "-82.4951991",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 419-610-8217",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019dac3e-74e9-7698-bcc8-fd1c4b58ca3f",
        "storage_key": "property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgamKIt7rOYgRnGXyEX6nuMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_f6fc39391a3d699b250e319d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Deschner’s",
      "poi_type": "Restaurants",
      "poi_address": "220 Ashland Rd, Mansfield, OH 44905, USA",
      "poi_short_description": "Low–key pizzeria offering pies with lots of toppings, big slices, subs & more in informal surrounds.",
      "poi_long_description": "Low–key pizzeria offering pies with lots of toppings, big slices, subs & more in informal surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-9230-7587-97f7-6bf8cf7f5cd1.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior signage for a business named DESCHNER'S.",
        "public_id": "019dbbf0-9230-7587-97f7-6bf8cf7f5cd1",
        "storage_key": "property/6767906449167350/019dbbf0-9230-7587-97f7-6bf8cf7f5cd1.webp",
        "width": 2268,
        "height": 2230
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10759245052057846584&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deschners",
      "poi_latitude": "40.7621454",
      "poi_longitude": "-82.4989305",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 419-524-4400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019dac3e-74e9-7698-bcc8-fd1c4b58ca3f",
        "storage_key": "property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpabJWrbrOYgROINJs16EUJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "meal_takeaway"
    },
    {
      "id": "ec_29a320bfdc7aa9a4e74a08d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Donatos Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1509 Lexington Ave, Mansfield, OH 44907, USA",
      "poi_short_description": "Chain selling crispy pizzas featuring provolone cheese & lots of toppings, plus oven-baked subs.",
      "poi_long_description": "Chain selling crispy pizzas featuring provolone cheese & lots of toppings, plus oven-baked subs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-92ae-738c-8984-43f4d7174fa0.webp",
      "poi_featured_image_media": {
        "alt_text": "Donatos Pizza exterior with snow on the roof.",
        "public_id": "019dbbf0-92ae-738c-8984-43f4d7174fa0",
        "storage_key": "property/6767906449167350/019dbbf0-92ae-738c-8984-43f4d7174fa0.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.donatos.com/?location=43",
      "poi_directions_map_url": "https://maps.google.com/?cid=16315817517948603856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donatos-pizza",
      "poi_latitude": "40.7181162",
      "poi_longitude": "-82.54601339999999",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-756-5885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019dac3e-74e9-7698-bcc8-fd1c4b58ca3f",
        "storage_key": "property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg5LD7JPqOYgR0A1scZZtbeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_fd8f49c4cc1cbeb3e6c282ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Smokin Bros BBQ Voted # 1",
      "poi_type": "Restaurants",
      "poi_address": "1041 Park Ave W, Mansfield, OH 44903, USA",
      "poi_short_description": "Bright, fast-food style eatery offering an array of BBQ smoked meats, ribs & hearty sides.",
      "poi_long_description": "Bright, fast-food style eatery offering an array of BBQ smoked meats, ribs & hearty sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-5be9-746f-82c0-e4dc375c509b.webp",
      "poi_featured_image_media": {
        "alt_text": "Conference room with large TV displaying a scenic lake view with boats.",
        "public_id": "019dac40-5be9-746f-82c0-e4dc375c509b",
        "storage_key": "property/6767906449167350/019dac40-5be9-746f-82c0-e4dc375c509b.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.smokinbrosbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5866062712703817057&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smokin-bros-bbq-voted--1",
      "poi_latitude": "40.7588775",
      "poi_longitude": "-82.55383599999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 855-800-8820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019dac3e-74e9-7698-bcc8-fd1c4b58ca3f",
        "storage_key": "property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYkK1aDqOYgRYRXgHPVwaFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_9dca89390a1604542561b0eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Brown Derby Road House",
      "poi_type": "Restaurants",
      "poi_address": "3985 Park Ave W, Ontario, OH 44906, USA",
      "poi_short_description": "Local chain steakhouse dishing wood-fired meats, seafood, salads & sides in a warm, clubby setting.",
      "poi_long_description": "Local chain steakhouse dishing wood-fired meats, seafood, salads & sides in a warm, clubby setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-6896-735f-9823-1fec834e4a36.webp",
      "poi_featured_image_media": {
        "alt_text": "Brown Derby Roadhouse restaurant exterior with red siding and covered patio area.",
        "public_id": "019dac40-6896-735f-9823-1fec834e4a36",
        "storage_key": "property/6767906449167350/019dac40-6896-735f-9823-1fec834e4a36.webp",
        "width": 2416,
        "height": 3072
      },
      "poi_business_url": "http://www.ontarioroadhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17356953709004300496&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brown-derby-road-house",
      "poi_latitude": "40.7623733",
      "poi_longitude": "-82.6573743",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 46 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 419-529-2959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019dac3e-74e9-7698-bcc8-fd1c4b58ca3f",
        "storage_key": "property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTd0C5HyWOYgR0KAZ8G9J4PA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "ec_f77624e72d4d169a08b3d9b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "575 N Lexington-Springmill Rd, Mansfield, OH 44906, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63af-df64-722a-800f-e2fcb6af7787.webp",
      "poi_featured_image_media": {
        "alt_text": "Golden Corral restaurant exterior at dusk with illuminated sign and entrance.",
        "public_id": "019d63af-df64-722a-800f-e2fcb6af7787",
        "storage_key": "property/6767906449167350/019d63af-df64-722a-800f-e2fcb6af7787.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/968/golden-corral-n-lexington-spring-mall?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=968",
      "poi_directions_map_url": "https://maps.google.com/?cid=8015495909771283206&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "40.7670136",
      "poi_longitude": "-82.59107139999999",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 419-529-9093",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019dac3e-74e9-7698-bcc8-fd1c4b58ca3f",
        "storage_key": "property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6YPiQOSUOYgRBouD4A_DPG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "ec_e7c2641fa896359e4de393d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "500 Park Avenue Cafe",
      "poi_type": "Restaurants",
      "poi_address": "500 Park Ave W, Mansfield, OH 44903, USA",
      "poi_short_description": "Informal eating spot dishing up gyros and other staples, plus chicken, burgers and salads.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-9878-740e-88f0-89af863bd626.webp",
      "poi_featured_image_media": {
        "alt_text": "Children playing on slot machines in an arcade area.",
        "public_id": "019dbbf0-9878-740e-88f0-89af863bd626",
        "storage_key": "property/6767906449167350/019dbbf0-9878-740e-88f0-89af863bd626.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16321726584030834664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "500-park-avenue-cafe",
      "poi_latitude": "40.7592158",
      "poi_longitude": "-82.5339267",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 567-307-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019dac3e-74e9-7698-bcc8-fd1c4b58ca3f",
        "storage_key": "property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy7Ws2yPrOYgR6C81GtprguI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_c626da7a7b31fe04a0e9a214",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Bar Pregame",
      "poi_type": "Restaurants",
      "poi_address": "1349 Park Ave W, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-9cd6-766f-a413-11e829e01d14.webp",
      "poi_featured_image_media": {
        "alt_text": "Bar area with bottles of alcohol on shelves and two televisions displaying advertisements.",
        "public_id": "019dbbf0-9cd6-766f-a413-11e829e01d14",
        "storage_key": "property/6767906449167350/019dbbf0-9cd6-766f-a413-11e829e01d14.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://restoer.com/bar-pregame",
      "poi_directions_map_url": "https://maps.google.com/?cid=12764348355569392752&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bar-pregame",
      "poi_latitude": "40.7589907",
      "poi_longitude": "-82.56459900000002",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 419-709-8755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf1-01ef-7699-9ddf-b4a23e2b8d76.webp",
      "poi_map_icon_media": {
        "alt_text": "Martini glass icon",
        "public_id": "019dbbf1-01ef-7699-9ddf-b4a23e2b8d76",
        "storage_key": "property/6767906449167350/019dbbf1-01ef-7699-9ddf-b4a23e2b8d76.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtRvXc3KVOYgRcBwOczMTJLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_a50895777a804f0c14c200e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Mansfield Family Restaurant - Westside",
      "poi_type": "Restaurants",
      "poi_address": "1090 Park Ave W, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-85c9-706f-947a-ac09032fb73f.webp",
      "poi_featured_image_media": {
        "alt_text": "Slice of cherry pie topped with whipped cream.",
        "public_id": "019dac40-85c9-706f-947a-ac09032fb73f",
        "storage_key": "property/6767906449167350/019dac40-85c9-706f-947a-ac09032fb73f.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://www.mansfieldfamilyrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4720539796355018875&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mansfield-family-restaurant---westside",
      "poi_latitude": "40.759556",
      "poi_longitude": "-82.5550442",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-529-8238",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon of a fork and knife",
        "public_id": "019dac3e-74e9-7698-bcc8-fd1c4b58ca3f",
        "storage_key": "property/6767906449167350/019dac3e-74e9-7698-bcc8-fd1c4b58ca3f.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx9yO3inrOYgRe_DVLe-5gkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "family_restaurant"
    },
    {
      "id": "ec_b4400dcfd6de6878d0e82bff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "30 E Cook Rd, Mansfield, OH 44907, USA",
      "poi_short_description": "Convenience store and gas station chain offering coffee, drinks, and prepared foods, plus an ATM.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b6-c6f8-73cb-bc63-6fb1ecbdcc51.webp",
      "poi_featured_image_media": {
        "alt_text": "A store associate in a red shirt hands a customer a receipt at a convenience store.",
        "public_id": "019d63b6-c6f8-73cb-bc63-6fb1ecbdcc51",
        "storage_key": "property/6767906449167350/019d63b6-c6f8-73cb-bc63-6fb1ecbdcc51.webp",
        "width": 1770,
        "height": 1180
      },
      "poi_business_url": "https://www.circlek.com/store-locator/US/mansfield/30-e-cook-rd/4705705?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=941521205412160940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "40.7325496",
      "poi_longitude": "-82.5127066",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 419-775-8863",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac41-017a-7675-96b2-d9231a7198e6.webp",
      "poi_map_icon_media": {
        "alt_text": "Generic store icon",
        "public_id": "019dac41-017a-7675-96b2-d9231a7198e6",
        "storage_key": "property/6767906449167350/019dac41-017a-7675-96b2-d9231a7198e6.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ9_kixWbqOYgRrOUWRYz0EA0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_bbc0fc5c03a52fae338d4d3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2485 Possum Run Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "Selection of home products, electronics, clothing, toys, auto supplies and other goods.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b6-d3f1-7760-9c54-455ff2a0ce05.webp",
      "poi_featured_image_media": {
        "alt_text": "Walmart logo on the side of a store with an American flag waving.",
        "public_id": "019d63b6-d3f1-7760-9c54-455ff2a0ce05",
        "storage_key": "property/6767906449167350/019d63b6-d3f1-7760-9c54-455ff2a0ce05.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/5471-mansfield-oh/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7274873837405389574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "40.6920297",
      "poi_longitude": "-82.5080976",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-756-2850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-a6fb71bc97d6.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019dac3e-74f5-70fc-8505-a6fb71bc97d6",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-a6fb71bc97d6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJw2nCYLfBOYgRBsNUEDaL9WQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_02a7158288bc1e9add2876b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Ontario Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "2205 Walker Lake Rd, Ontario, OH 44903, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-8718-75fa-a1b1-42ecd2c889fe.webp",
      "poi_featured_image_media": {
        "alt_text": "Target store entrance with large red circular logo above the doors.",
        "public_id": "019dac40-8718-75fa-a1b1-42ecd2c889fe",
        "storage_key": "property/6767906449167350/019dac40-8718-75fa-a1b1-42ecd2c889fe.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.target.com/sl/mansfield/1381",
      "poi_directions_map_url": "https://maps.google.com/?cid=16433501694553806929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ontario-target",
      "poi_latitude": "40.7857864",
      "poi_longitude": "-82.59396939999999",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 419-747-1313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-a6fb71bc97d6.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019dac3e-74f5-70fc-8505-a6fb71bc97d6",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-a6fb71bc97d6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIxKUb5GUOYgRUdioB7mGD-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_831fd6f4eb3cd2585974d067",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Meijer",
      "poi_type": "Shopping & Retail",
      "poi_address": "1355 N Lexington-Springmill Rd, Ontario, OH 44906, USA",
      "poi_short_description": "Chain retailer featuring brand-name groceries plus apparel, electronics & more.",
      "poi_long_description": "Chain retailer featuring brand-name groceries plus apparel, electronics & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b7-b625-775f-8b19-d9351768c553.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a large retail store with the word \"home\" above the entrance.",
        "public_id": "019d63b7-b625-775f-8b19-d9351768c553",
        "storage_key": "property/6767906449167350/019d63b7-b625-775f-8b19-d9351768c553.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.meijer.com/shopping/store-locator/126.html?cmpid=LM:Web::::05112021::GoogleGrocery",
      "poi_directions_map_url": "https://maps.google.com/?cid=9772672014740695750&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meijer",
      "poi_latitude": "40.7895314",
      "poi_longitude": "-82.5929474",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 419-747-8300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e8-75b9-91ee-77a008af616c.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019dac3e-74e8-75b9-91ee-77a008af616c",
        "storage_key": "property/6767906449167350/019dac3e-74e8-75b9-91ee-77a008af616c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9e0pwpCUOYgRxioFaWuBn4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_1ac65d3dcab64ef24fac4f22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "1060 Ashland Rd, Mansfield, OH 44905, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-31db-76e7-9e31-d8e8eafd97fb.webp",
      "poi_featured_image_media": {
        "alt_text": "Kroger grocery store exterior with signage and shopping carts.",
        "public_id": "019dac3e-31db-76e7-9e31-d8e8eafd97fb",
        "storage_key": "property/6767906449167350/019dac3e-31db-76e7-9e31-d8e8eafd97fb.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/oh/mansfield/ashland-road/016/00557?cid=loc_01600557_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17819052776187630567&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "40.7740094",
      "poi_longitude": "-82.47580830000001",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-589-3147",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e8-75b9-91ee-77a008af616c.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019dac3e-74e8-75b9-91ee-77a008af616c",
        "storage_key": "property/6767906449167350/019dac3e-74e8-75b9-91ee-77a008af616c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzS2PBODrOYgR5xOaLhf-Sfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_53c1d355095b46f004714984",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2205 Walker Lake Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-bd24-701d-a519-aa51400546d0.webp",
      "poi_featured_image_media": {
        "alt_text": "Mother and daughter shopping in a CVS pharmacy",
        "public_id": "019dbbf0-bd24-701d-a519-aa51400546d0",
        "storage_key": "property/6767906449167350/019dbbf0-bd24-701d-a519-aa51400546d0.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/mansfield-oh-pharmacies/2205-walker-lake-rd-mansfield-oh-44903/storeid=16720?WT.mc_id=LS_GOOGLE_RX_16720",
      "poi_directions_map_url": "https://maps.google.com/?cid=4483669251022079216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.7857864",
      "poi_longitude": "-82.59396939999999",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 419-747-1450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac41-0174-702a-9255-d1697b7b75dc.webp",
      "poi_map_icon_media": {
        "alt_text": "Pharmacy or medical cross icon",
        "public_id": "019dac41-0174-702a-9255-d1697b7b75dc",
        "storage_key": "property/6767906449167350/019dac41-0174-702a-9255-d1697b7b75dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJExOUb5GUOYgR8ESDpW0xOT4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d113f8b125e21312d0e4284b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "E K Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "929 Springmill St, Mansfield, OH 44906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16258931114624670739&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "e-k-market",
      "poi_latitude": "40.783953",
      "poi_longitude": "-82.54978969999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 419-747-1256",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74e8-75b9-91ee-77a008af616c.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping cart icon",
        "public_id": "019dac3e-74e8-75b9-91ee-77a008af616c",
        "storage_key": "property/6767906449167350/019dac3e-74e8-75b9-91ee-77a008af616c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCU2T5kXrOYgRE9y_irRTo-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_6df549cc6c43f1338aead87d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "458 Springmill St, Mansfield, OH 44903, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b7-2bbf-77fd-80c9-1bf06c5ced38.webp",
      "poi_featured_image_media": {
        "alt_text": "Dollar General store exterior with a large yellow sign.",
        "public_id": "019d63b7-2bbf-77fd-80c9-1bf06c5ced38",
        "storage_key": "property/6767906449167350/019d63b7-2bbf-77fd-80c9-1bf06c5ced38.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/oh/mansfield/14503",
      "poi_directions_map_url": "https://maps.google.com/?cid=12599142676466904924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "40.7693552",
      "poi_longitude": "-82.5223687",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 419-982-2952",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-a6fb71bc97d6.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019dac3e-74f5-70fc-8505-a6fb71bc97d6",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-a6fb71bc97d6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7R5q5wjrOYgRXC9G2YIl2a4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_13793aa0b19be95943c138cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "2279 Walker Lake Rd Ste 100, Ontario, OH 44906, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-b169-7506-8541-d9e83c533a15.webp",
      "poi_featured_image_media": {
        "alt_text": "ULTA Beauty store exterior with orange awnings and prominent logo.",
        "public_id": "019dbbf0-b169-7506-8541-d9e83c533a15",
        "storage_key": "property/6767906449167350/019dbbf0-b169-7506-8541-d9e83c533a15.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/ontario-oh-675",
      "poi_directions_map_url": "https://maps.google.com/?cid=8739353079721206319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "40.7877282",
      "poi_longitude": "-82.59576849999999",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 419-747-2065",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-a6fb71bc97d6.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019dac3e-74f5-70fc-8505-a6fb71bc97d6",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-a6fb71bc97d6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJKWVbd5GUOYgRL6J_q1JrSHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cosmetics_store"
    },
    {
      "id": "ec_f21db33b7ca1fc98fc3f8651",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Old Navy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2259 Walker Lake Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_long_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-bc7b-74fa-af43-ac7aa00b99b2.webp",
      "poi_featured_image_media": {
        "alt_text": "Old Navy store logo and storefront",
        "public_id": "019dbbf0-bc7b-74fa-af43-ac7aa00b99b2",
        "storage_key": "property/6767906449167350/019dbbf0-bc7b-74fa-af43-ac7aa00b99b2.webp",
        "width": 2048,
        "height": 1536
      },
      "poi_business_url": "https://oldnavy.gap.com/stores/oh/mansfield/oldnavy-7272.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13064459995074151091&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-navy",
      "poi_latitude": "40.7857484",
      "poi_longitude": "-82.59582759999999",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 567-327-3143",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-a6fb71bc97d6.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019dac3e-74f5-70fc-8505-a6fb71bc97d6",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-a6fb71bc97d6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJO11h-VvrOYgRs0KypCVJTrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_8a3d6a74cdf37eb1ec8bdaf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Madison South Elementary School",
      "poi_type": "Education",
      "poi_address": "700 S Illinois Ave, Mansfield, OH 44907, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://mlsd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11588494899236505428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madison-south-elementary-school",
      "poi_latitude": "40.7390098",
      "poi_longitude": "-82.4858003",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 419-522-4319",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWWj0ZiPqOYgRVAdrXraa0qA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_38297b4d95356a942e0f32c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Mifflin Elementary School",
      "poi_type": "Education",
      "poi_address": "441 Reed Rd, Mansfield, OH 44905, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mlsd.net/o/mes",
      "poi_directions_map_url": "https://maps.google.com/?cid=13337425445311902506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mifflin-elementary-school",
      "poi_latitude": "40.7674946",
      "poi_longitude": "-82.4276225",
      "poi_miles_from_property": "5.7 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 419-589-6517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn3SFM-foOYgRKnMSHscNGLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_0d8d7d2fb54e20ddd2c295e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Eastview Elementary School",
      "poi_type": "Education",
      "poi_address": "1262 Eastview Dr, Mansfield, OH 44905, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mlsd.net/o/ees",
      "poi_directions_map_url": "https://maps.google.com/?cid=10807768049129486624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastview-elementary-school",
      "poi_latitude": "40.7929259",
      "poi_longitude": "-82.4596881",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-589-7335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOf8ExEzpOYgRIPktV8fn_JU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_1f6641dbefeead5e9ae634f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Madison Middle School",
      "poi_type": "Education",
      "poi_address": "1419 Grace St, Mansfield, OH 44905, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-c047-719d-a45d-d4f7e4eda070.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a brick building with a large glass entrance and parking lot.",
        "public_id": "019dbbf0-c047-719d-a45d-d4f7e4eda070",
        "storage_key": "property/6767906449167350/019dbbf0-c047-719d-a45d-d4f7e4eda070.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://www.mlsd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6619768385718671909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madison-middle-school",
      "poi_latitude": "40.7718958",
      "poi_longitude": "-82.4624687",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-522-0471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGUIZR2jpOYgRJVofFkYk3ls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_39285fbbc9db736393211570",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Madison High School, llc",
      "poi_type": "Education",
      "poi_address": "600 Esley Ln, Mansfield, OH 44905, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-c3e6-70e2-a1f6-8d7edd218661.webp",
      "poi_featured_image_media": {
        "alt_text": "Football field with players practicing and spectators in the stands.",
        "public_id": "019dbbf0-c3e6-70e2-a1f6-8d7edd218661",
        "storage_key": "property/6767906449167350/019dbbf0-c3e6-70e2-a1f6-8d7edd218661.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://mlsd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3634665017302573235&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madison-high-school-llc",
      "poi_latitude": "40.7747221",
      "poi_longitude": "-82.46061209999999",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 419-589-2112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOct_hUHpOYgRs-DbcZPscDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_595c6ffa7521b8bd8a9ca09e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Madison Early Childhood Learning",
      "poi_type": "Education",
      "poi_address": "1035 Grace St, Mansfield, OH 44905, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mlsd.net/o/mecl",
      "poi_directions_map_url": "https://maps.google.com/?cid=936373832934776359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madison-early-childhood-learning",
      "poi_latitude": "40.7708807",
      "poi_longitude": "-82.4770626",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-589-7851",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAySpMc3rOYgRJ14MOQqr_gw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_f30e886fe60dbe1acbeb6d5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Malabar Intermediate School",
      "poi_type": "Education",
      "poi_address": "205 W Cook Rd, Mansfield, OH 44906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b7-7de1-779d-bd6a-21448ed813da.webp",
      "poi_featured_image_media": {
        "alt_text": "Wrestling match in progress with a referee and two wrestlers in the ring.",
        "public_id": "019d63b7-7de1-779d-bd6a-21448ed813da",
        "storage_key": "property/6767906449167350/019d63b7-7de1-779d-bd6a-21448ed813da.webp",
        "width": 1728,
        "height": 3072
      },
      "poi_business_url": "http://www.tygerpride.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7446497911231035733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "malabar-intermediate-school",
      "poi_latitude": "40.730028",
      "poi_longitude": "-82.52127159999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 419-525-6374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUZ8JoInqOYgRVTmdo2VGV2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_1af060a1fb9cec7b010ef72f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Spanish Immersion School",
      "poi_type": "Education",
      "poi_address": "240 Euclid Ave, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.mansfieldschools.org/spanishimmersionschool_home.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=2349897367855815404&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spanish-immersion-school",
      "poi_latitude": "40.75225289999999",
      "poi_longitude": "-82.5409488",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 419-525-6321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR_wk_93qOYgR7NqrrTSDnCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_9d566ec2d020205d41ed9f5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "DISCOVERY SCHOOL",
      "poi_type": "Education",
      "poi_address": "855 Millsboro East Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.discovery-school.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18359492258501533876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-school",
      "poi_latitude": "40.746736",
      "poi_longitude": "-82.54749699999999",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-756-8880",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmSnnvcTqOYgRtKCEtO8Eyv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_4ab2ce3644417bc06c6496c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "The Ohio State University at Mansfield",
      "poi_type": "Education",
      "poi_address": "1760 University Dr, Mansfield, OH 44906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b8-f080-7761-9a29-f95a7be3d6a2.webp",
      "poi_featured_image_media": {
        "alt_text": "OSU Theatre display case featuring posters of William Shakespeare productions, lit with colorful bulbs.",
        "public_id": "019d63b8-f080-7761-9a29-f95a7be3d6a2",
        "storage_key": "property/6767906449167350/019d63b8-f080-7761-9a29-f95a7be3d6a2.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://mansfield.osu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4049580252666124585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ohio-state-university-at-mansfield",
      "poi_latitude": "40.7971264",
      "poi_longitude": "-82.5794396",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 419-755-4317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqymbFqGUOYgRKdmZwcj_Mjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_34362abfe02e3632dde1c3ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "The Ohio State Reformatory",
      "poi_type": "Entertainment",
      "poi_address": "100 Reformatory Rd, Mansfield, OH 44905, USA",
      "poi_short_description": "Built in 1886, this Romanesque Revival prison was featured in the film \"The Shawshank Redemption.\"",
      "poi_long_description": "Built in 1886, this Romanesque Revival prison was featured in the film \"The Shawshank Redemption.\"",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-4d12-71f4-b9a2-f9f9c5877f60.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a grand, historic stone building with multiple wings and a central tower.",
        "public_id": "019dac3e-4d12-71f4-b9a2-f9f9c5877f60",
        "storage_key": "property/6767906449167350/019dac3e-4d12-71f4-b9a2-f9f9c5877f60.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.mrps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2336389288342511839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ohio-state-reformatory",
      "poi_latitude": "40.784215",
      "poi_longitude": "-82.502481",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-522-2644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a1ec99c1ffdc.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon with the letter M inside a building shape.",
        "public_id": "019dac3e-7519-70f0-be15-a1ec99c1ffdc",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a1ec99c1ffdc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJA-CyiZHrOYgR3-Cu1K2FbCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_ef2d1be0c0565426eea06ebd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Renaissance Theatre",
      "poi_type": "Entertainment",
      "poi_address": "138 Park Ave W, Mansfield, OH 44903, USA",
      "poi_short_description": "A fully restored historic movie palace featuring theater, music, dance & comedy performances.",
      "poi_long_description": "A fully restored historic movie palace featuring theater, music, dance & comedy performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-9c7b-746d-9076-b5744bab9df8.webp",
      "poi_featured_image_media": {
        "alt_text": "Audience seated in a vintage theater watching a panel discussion on stage.",
        "public_id": "019dac40-9c7b-746d-9076-b5744bab9df8",
        "storage_key": "property/6767906449167350/019dac40-9c7b-746d-9076-b5744bab9df8.webp",
        "width": 2936,
        "height": 1980
      },
      "poi_business_url": "https://rentickets.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10577359845094451109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "renaissance-theatre",
      "poi_latitude": "40.7591015",
      "poi_longitude": "-82.5205443",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-522-2726",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg15_WgDrOYgRpedV5LxUypI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_95f48d25e7bef4233721c9d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Kingwood Center Gardens",
      "poi_type": "Entertainment",
      "poi_address": "50 N Trimble Rd, Mansfield, OH 44906, USA",
      "poi_short_description": "Former estate grounds spanning 47 acres featuring a variety of formal gardens, with tours available.",
      "poi_long_description": "Former estate grounds spanning 47 acres featuring a variety of formal gardens, with tours available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b1-8800-703e-b319-e05316b77f34.webp",
      "poi_featured_image_media": {
        "alt_text": "Grand brick building with a prominent arched entrance and multiple windows.",
        "public_id": "019d63b1-8800-703e-b319-e05316b77f34",
        "storage_key": "property/6767906449167350/019d63b1-8800-703e-b319-e05316b77f34.webp",
        "width": 2119,
        "height": 1192
      },
      "poi_business_url": "http://www.kingwoodcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1898681523339425512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kingwood-center-gardens",
      "poi_latitude": "40.760457",
      "poi_longitude": "-82.5515482",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 419-522-0211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN6VwH07rOYgR6HY-LMl4WRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_74d61ce040ce902203e3ff8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Richland Carrousel Park",
      "poi_type": "Entertainment",
      "poi_address": "75 N Main St, Mansfield, OH 44903, USA",
      "poi_short_description": "Pavilion with a recently built, hand-carved carousel with organ music, plus a gift shop.",
      "poi_long_description": "Pavilion with a recently built, hand-carved carousel with organ music, plus a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b8-6dc5-7269-91dc-59c73180633e.webp",
      "poi_featured_image_media": {
        "alt_text": "Entrance to Richland Carousel Park with statues of horses and flags.",
        "public_id": "019d63b8-6dc5-7269-91dc-59c73180633e",
        "storage_key": "property/6767906449167350/019d63b8-6dc5-7269-91dc-59c73180633e.webp",
        "width": 1079,
        "height": 812
      },
      "poi_business_url": "http://www.richlandcarrousel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18303933482233699477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richland-carrousel-park",
      "poi_latitude": "40.7607055",
      "poi_longitude": "-82.5158355",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-522-4223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvwhUM6rrOYgRlRzrEIaiBP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_653c9cfb447d9a75b75bc429",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Buckeye Imagination Museum",
      "poi_type": "Entertainment",
      "poi_address": "175 W 3rd St, Mansfield, OH 44903, USA",
      "poi_short_description": "Hands-on children's displays including mini stores, a water table, a building zone & a train room.",
      "poi_long_description": "Hands-on children's displays including mini stores, a water table, a building zone & a train room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b0-1834-74b6-955d-74ce5f8b30c3.webp",
      "poi_featured_image_media": {
        "alt_text": "Buckeye Imagination Museum building exterior with brick facade and covered entrance.",
        "public_id": "019d63b0-1834-74b6-955d-74ce5f8b30c3",
        "storage_key": "property/6767906449167350/019d63b0-1834-74b6-955d-74ce5f8b30c3.webp",
        "width": 750,
        "height": 563
      },
      "poi_business_url": "https://buckeyeimaginationmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13921819218402865031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buckeye-imagination-museum",
      "poi_latitude": "40.7591549",
      "poi_longitude": "-82.5219273",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-522-2332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a1ec99c1ffdc.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon with the letter M inside a building shape.",
        "public_id": "019dac3e-7519-70f0-be15-a1ec99c1ffdc",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a1ec99c1ffdc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8FYIqrrOYgRh-8bdNE8NME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_c0d56098c56e7a1f7d9b75f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Mansfield Memorial Museum",
      "poi_type": "Entertainment",
      "poi_address": "34 Park Ave W, Mansfield, OH 44902, USA",
      "poi_short_description": "Stalwart from 1889 displaying exhibits on military, aviation & natural history, plus a 1939 robot.",
      "poi_long_description": "Stalwart from 1889 displaying exhibits on military, aviation & natural history, plus a 1939 robot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-a17d-7028-bdae-936b182a0918.webp",
      "poi_featured_image_media": {
        "alt_text": "Woman standing between three large robots.",
        "public_id": "019dac40-a17d-7028-bdae-936b182a0918",
        "storage_key": "property/6767906449167350/019dac40-a17d-7028-bdae-936b182a0918.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://themansfieldmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11422426663650339691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mansfield-memorial-museum",
      "poi_latitude": "40.758788",
      "poi_longitude": "-82.5170469",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 419-525-2491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a1ec99c1ffdc.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon with the letter M inside a building shape.",
        "public_id": "019dac3e-7519-70f0-be15-a1ec99c1ffdc",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a1ec99c1ffdc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJu-Z-9KrrOYgRayvUL4ichJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_83e679afcc67a2714f04e682",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Springmill Drive-In Theater",
      "poi_type": "Entertainment",
      "poi_address": "1040 OH-39, Mansfield, OH 44906, USA",
      "poi_short_description": "Seasonal 1950s-style drive-in featuring 2 screens for first-run movies, plus a concession stand.",
      "poi_long_description": "Seasonal 1950s-style drive-in featuring 2 screens for first-run movies, plus a concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-9c10-76a6-893e-b5969fba331a.webp",
      "poi_featured_image_media": {
        "alt_text": "Springmill drive-in movie theater screen and entrance.",
        "public_id": "019dac40-9c10-76a6-893e-b5969fba331a",
        "storage_key": "property/6767906449167350/019dac40-9c10-76a6-893e-b5969fba331a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.springmilldrive-in.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11259948239331101590&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springmill-drive-in-theater",
      "poi_latitude": "40.7885671",
      "poi_longitude": "-82.557181",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 419-747-2156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac41-0167-75d6-9de2-8cee597b010a.webp",
      "poi_map_icon_media": {
        "alt_text": "Video reel icon",
        "public_id": "019dac41-0167-75d6-9de2-8cee597b010a",
        "storage_key": "property/6767906449167350/019dac41-0167-75d6-9de2-8cee597b010a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJF5yGAE7rOYgRloudEkRfQ5w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_a212e7e32875874236804262",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Cinemark Ontario Towne Center",
      "poi_type": "Entertainment",
      "poi_address": "2355 Walker Lake Rd, Center, Ontario, OH 44906, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-9fa7-7080-b683-470a827b49f4.webp",
      "poi_featured_image_media": {
        "alt_text": "Cinemark movie theater exterior at night with illuminated signage.",
        "public_id": "019dac40-9fa7-7080-b683-470a827b49f4",
        "storage_key": "property/6767906449167350/019dac40-9fa7-7080-b683-470a827b49f4.webp",
        "width": 3072,
        "height": 2313
      },
      "poi_business_url": "https://www.cinemark.com/theatres/oh-ontario/cinemark-ontario-towne-center?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5NDItNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10009907889717531909&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-ontario-towne-center",
      "poi_latitude": "40.7850283",
      "poi_longitude": "-82.5994247",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 419-589-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac41-0167-75d6-9de2-8cee597b010a.webp",
      "poi_map_icon_media": {
        "alt_text": "Video reel icon",
        "public_id": "019dac41-0167-75d6-9de2-8cee597b010a",
        "storage_key": "property/6767906449167350/019dac41-0167-75d6-9de2-8cee597b010a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJd2tmkJGUOYgRBVX-4DBW6oo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_d39c48f34b09a79093f85c4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Biblewalk",
      "poi_type": "Entertainment",
      "poi_address": "500 Tingley Ave, Mansfield, OH 44905, USA",
      "poi_short_description": "Waxwork museum with around 300 biblical figures, rare bibles, art & wood carvings, with tours.",
      "poi_long_description": "Waxwork museum with around 300 biblical figures, rare bibles, art & wood carvings, with tours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b0-2573-7578-938c-d20cddacd0f2.webp",
      "poi_featured_image_media": {
        "alt_text": "Man walking through a giant open Bible, \"BibleWalk\" graphic overlay",
        "public_id": "019d63b0-2573-7578-938c-d20cddacd0f2",
        "storage_key": "property/6767906449167350/019d63b0-2573-7578-938c-d20cddacd0f2.webp",
        "width": 940,
        "height": 788
      },
      "poi_business_url": "https://www.biblewalk.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17438341905874710588&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "biblewalk",
      "poi_latitude": "40.7859965",
      "poi_longitude": "-82.4957759",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-524-0139",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a1ec99c1ffdc.webp",
      "poi_map_icon_media": {
        "alt_text": "Icon with the letter M inside a building shape.",
        "public_id": "019dac3e-7519-70f0-be15-a1ec99c1ffdc",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a1ec99c1ffdc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJtUsko_LrOYgRPHB4M5JvAfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_74686192c7a86d3d3c114004",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Gorman Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "2295 Lexington Ave, Mansfield, OH 44906, USA",
      "poi_short_description": "150-acre preserve with a visitor center & trails, plus naturalist-led hikes & night-sky programs.",
      "poi_long_description": "150-acre preserve with a visitor center & trails, plus naturalist-led hikes & night-sky programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-0f92-72ec-b312-d0cf11fb39e1.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden boardwalk over a pond with lily pads and reeds.",
        "public_id": "019d63b2-0f92-72ec-b312-d0cf11fb39e1",
        "storage_key": "property/6767906449167350/019d63b2-0f92-72ec-b312-d0cf11fb39e1.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.richlandcountyoh.gov/departments/RichlandCountParksDistrict",
      "poi_directions_map_url": "https://maps.google.com/?cid=1290097879386109782&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gorman-nature-center",
      "poi_latitude": "40.699768",
      "poi_longitude": "-82.5563221",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-884-3764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019dac3e-7519-70f0-be15-a74e51740971",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZytWAzAOYgRVjdLoi9Z5xE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ccfdf8d97ba429cb5649337d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "OhioHealth Mansfield Hospital and Emergency Department",
      "poi_type": "Health and Wellness",
      "poi_address": "335 Glessner Ave, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b1-6c50-75a9-81fa-e2433c85bf3d.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a modern brick building with an American flag waving in front.",
        "public_id": "019d63b1-6c50-75a9-81fa-e2433c85bf3d",
        "storage_key": "property/6767906449167350/019d63b1-6c50-75a9-81fa-e2433c85bf3d.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.ohiohealth.com/locations/hospitals/mansfield-hospital/?utm_source=yext&utm_medium=listings&utm_campaign=websiteclicksfacility",
      "poi_directions_map_url": "https://maps.google.com/?cid=1107658932139026326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ohiohealth-mansfield-hospital-and-emergency-department",
      "poi_latitude": "40.752648",
      "poi_longitude": "-82.5295987",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 419-526-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f6-73fa-bc42-c1040a72048d.webp",
      "poi_map_icon_media": {
        "alt_text": "Logo of H",
        "public_id": "019dac3e-74f6-73fa-bc42-c1040a72048d",
        "storage_key": "property/6767906449167350/019dac3e-74f6-73fa-bc42-c1040a72048d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyx2imPzqOYgRlmdvHu4xXw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_b08dddf4017b3ca109fea2f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Walk In Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "1341 S Trimble Rd, Mansfield, OH 44907, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-ce67-709c-92b2-a677fd152e06.webp",
      "poi_featured_image_media": {
        "alt_text": "Signage for Walk In Urgent Care and the building exterior.",
        "public_id": "019dbbf0-ce67-709c-92b2-a677fd152e06",
        "storage_key": "property/6767906449167350/019dbbf0-ce67-709c-92b2-a677fd152e06.webp",
        "width": 1600,
        "height": 1200
      },
      "poi_business_url": "https://walkinurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9681643891557958867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walk-in-urgent-care",
      "poi_latitude": "40.7214177",
      "poi_longitude": "-82.544775",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-775-7807",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLxJdNqHqOYgR04Qk5tIbXIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_c7bda43f0263e5af6375690d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Akron Children's Urgent Care, Mansfield",
      "poi_type": "Health and Wellness",
      "poi_address": "1029 S Trimble Rd, Mansfield, OH 44906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-d492-7335-9935-ab501418e30e.webp",
      "poi_featured_image_media": {
        "alt_text": "Akron Children's Hospital exterior",
        "public_id": "019dbbf0-d492-7335-9935-ab501418e30e",
        "storage_key": "property/6767906449167350/019dbbf0-d492-7335-9935-ab501418e30e.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://www.akronchildrens.org/locations/Urgent-Care-Mansfield.html?y_source=1_MTM0MDEzNjQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17902656078507653010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "akron-childrens-urgent-care-mansfield",
      "poi_latitude": "40.7338289",
      "poi_longitude": "-82.5502563",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-521-2950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGdRX8O_qOYgRkrdv39kCc_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_12f41021b8d6600065b07058",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2485 Possum Run Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-b77d-7584-bc1c-525e372f9987.webp",
      "poi_featured_image_media": {
        "alt_text": "Walmart entrance with ",
        "public_id": "019dac40-b77d-7584-bc1c-525e372f9987",
        "storage_key": "property/6767906449167350/019dac40-b77d-7584-bc1c-525e372f9987.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.walmart.com/store/5471-mansfield-oh/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13751192228786176571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "40.6920297",
      "poi_longitude": "-82.5080976",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-756-7177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac41-0174-702a-9255-d1697b7b75dc.webp",
      "poi_map_icon_media": {
        "alt_text": "Pharmacy or medical cross icon",
        "public_id": "019dac41-0174-702a-9255-d1697b7b75dc",
        "storage_key": "property/6767906449167350/019dac41-0174-702a-9255-d1697b7b75dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2nCYLfBOYgRO4LponkM1r4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_2c2ddc9dc46c88d33cedb8dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Ontario Target",
      "poi_type": "Health and Wellness",
      "poi_address": "2205 Walker Lake Rd, Ontario, OH 44903, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-8718-75fa-a1b1-42ecd2c889fe.webp",
      "poi_featured_image_media": {
        "alt_text": "Target store entrance with large red circular logo above the doors.",
        "public_id": "019dac40-8718-75fa-a1b1-42ecd2c889fe",
        "storage_key": "property/6767906449167350/019dac40-8718-75fa-a1b1-42ecd2c889fe.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.target.com/sl/mansfield/1381",
      "poi_directions_map_url": "https://maps.google.com/?cid=16433501694553806929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ontario-target",
      "poi_latitude": "40.7857864",
      "poi_longitude": "-82.59396939999999",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 5 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 419-747-1313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-a6fb71bc97d6.webp",
      "poi_map_icon_media": {
        "alt_text": "Shopping bag icon",
        "public_id": "019dac3e-74f5-70fc-8505-a6fb71bc97d6",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-a6fb71bc97d6.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIxKUb5GUOYgRUdioB7mGD-Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_fbd4849858c5ccdbf8a8591f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "755 Ashland Rd, Mansfield, OH 44905, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b7-659f-729c-8ef4-801cb6692fac.webp",
      "poi_featured_image_media": {
        "alt_text": "Drive-thru lane for a pharmacy with a car at the window.",
        "public_id": "019d63b7-659f-729c-8ef4-801cb6692fac",
        "storage_key": "property/6767906449167350/019d63b7-659f-729c-8ef4-801cb6692fac.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/mansfield-oh-pharmacies/755-ashland-road-mansfield-oh-44905/storeid=6175?WT.mc_id=LS_GOOGLE_RX_6175",
      "poi_directions_map_url": "https://maps.google.com/?cid=14717894768176495034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.7708889",
      "poi_longitude": "-82.486063",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-589-2030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac41-0174-702a-9255-d1697b7b75dc.webp",
      "poi_map_icon_media": {
        "alt_text": "Pharmacy or medical cross icon",
        "public_id": "019dac41-0174-702a-9255-d1697b7b75dc",
        "storage_key": "property/6767906449167350/019dac41-0174-702a-9255-d1697b7b75dc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUbhFtdzrOYgRunm9GlB3QMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_d225e733095833eebad60d0a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2166 W 4th St, Ontario, OH 44906, USA",
      "poi_short_description": "Chain gym offering a variety of equipment, plus tanning and massage chairs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b0-9653-75dd-ba14-82d3ddfb38cd.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of a Planet Fitness gym with various weight machines and people working out.",
        "public_id": "019d63b0-9653-75dd-ba14-82d3ddfb38cd",
        "storage_key": "property/6767906449167350/019d63b0-9653-75dd-ba14-82d3ddfb38cd.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/mansfield-oh?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4732658190959402840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "40.7739792",
      "poi_longitude": "-82.592342",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 419-709-8194",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5QfZXO6UOYgRWF96y4zHrUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_9b04283b9f39d39af4f6ed57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Mad-Fit",
      "poi_type": "Health and Wellness",
      "poi_address": "926 Ashland Rd, Mansfield, OH 44905, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63ba-26bf-750f-948c-3eae5a9498dd.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a martial arts gym with green trim and brick facade.",
        "public_id": "019d63ba-26bf-750f-948c-3eae5a9498dd",
        "storage_key": "property/6767906449167350/019d63ba-26bf-750f-948c-3eae5a9498dd.webp",
        "width": 2000,
        "height": 1500
      },
      "poi_business_url": "http://mad-fit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3349377133298583039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mad-fit",
      "poi_latitude": "40.7730543",
      "poi_longitude": "-82.4807409",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 419-589-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6qqqnrpOYgR_wUUycFgey4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_ec577dce1cfc7ae0ee97dd26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "YMCA of North Central Ohio-Mansfield",
      "poi_type": "Health and Wellness",
      "poi_address": "750 Scholl Rd, Mansfield, OH 44907, USA",
      "poi_short_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_long_description": "Community-focused nonprofit established in 1844 with recreational programs & services for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-bae4-754d-8798-8cc0e476c24e.webp",
      "poi_featured_image_media": {
        "alt_text": "YMCA building exterior with large windows and a monument sign.",
        "public_id": "019dac40-bae4-754d-8798-8cc0e476c24e",
        "storage_key": "property/6767906449167350/019dac40-bae4-754d-8798-8cc0e476c24e.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "http://www.ymcanco.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17090449832961305682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ymca-of-north-central-ohio-mansfield",
      "poi_latitude": "40.7377942",
      "poi_longitude": "-82.52938309999999",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 419-522-3511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLwLvIvPqOYgRUuxK8ZJ5Le0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_0b28361c217938bd431d250f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "BEyond FITness Studio, LLC. Pilates, Yoga, and Barre Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "340 Wood St, Mansfield, OH 44905, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.beyondfitstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17932140392445668124&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beyond-fitness-studio-llc-pilates-yoga-and-barre-studio",
      "poi_latitude": "40.7494892",
      "poi_longitude": "-82.5267219",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs5iB__rqOYgRHGsoqq3C2_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_e5f194b1667049bafb4e21db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Maple Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "746 Arlington Ave, Mansfield, OH 44903, USA",
      "poi_short_description": "State park featuring basketball, tennis, and a children's playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-d261-7161-838d-759405ea37f6.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground equipment with caution tape.",
        "public_id": "019dac40-d261-7161-838d-759405ea37f6",
        "storage_key": "property/6767906449167350/019dac40-d261-7161-838d-759405ea37f6.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15570733580391024283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maple-lake-park",
      "poi_latitude": "40.7517359",
      "poi_longitude": "-82.5433205",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 419-522-9801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019dac3e-7519-70f0-be15-a74e51740971",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKT-5RdzqOYgRmwZ0r7FbFtg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "ec_c224bb1dedd89c5d6b04f028",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "North Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "268 Hope Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "Cozy park adjacent to a paved rail corridor featuring a fishing lake, playground & picnic areas.",
      "poi_long_description": "Cozy park adjacent to a paved rail corridor featuring a fishing lake, playground & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63bb-8f3d-7290-be92-979ac9563cc0.webp",
      "poi_featured_image_media": {
        "alt_text": "Scenic lake view with colorful autumn trees in the background.",
        "public_id": "019d63bb-8f3d-7290-be92-979ac9563cc0",
        "storage_key": "property/6767906449167350/019d63bb-8f3d-7290-be92-979ac9563cc0.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7657225055596664205&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-lake-park",
      "poi_latitude": "40.7667847",
      "poi_longitude": "-82.5360772",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-522-9801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019dac3e-7519-70f0-be15-a74e51740971",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKV7gwBnrOYgRjVUPTJ7tQ2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "ec_3fda4aec41a50386f68cacb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Fleming Falls Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2294 Fleming Falls Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "Forest and meadows interlace this nature area, where trails wind past waterfalls and streams.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b1-e069-73bf-809d-f113fda7b8c4.webp",
      "poi_featured_image_media": {
        "alt_text": "Serene waterfall cascading into a pool surrounded by lush green trees and rocks.",
        "public_id": "019d63b1-e069-73bf-809d-f113fda7b8c4",
        "storage_key": "property/6767906449167350/019d63b1-e069-73bf-809d-f113fda7b8c4.webp",
        "width": 2301,
        "height": 3072
      },
      "poi_business_url": "https://www.richlandcountyoh.gov/departments/richlandcountparksdistrict/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12267172274387150554&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fleming-falls-preserve",
      "poi_latitude": "40.79786",
      "poi_longitude": "-82.43057069999999",
      "poi_miles_from_property": "6.9 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 419-884-3764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019dac3e-7519-70f0-be15-a74e51740971",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo44Ppo7vOYgR2uZddTDAPao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_58fa6d1a51ed2cab2c6fd25b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Gorman Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2295 Lexington Ave, Mansfield, OH 44906, USA",
      "poi_short_description": "150-acre preserve with a visitor center & trails, plus naturalist-led hikes & night-sky programs.",
      "poi_long_description": "150-acre preserve with a visitor center & trails, plus naturalist-led hikes & night-sky programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-0f92-72ec-b312-d0cf11fb39e1.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden boardwalk over a pond with lily pads and reeds.",
        "public_id": "019d63b2-0f92-72ec-b312-d0cf11fb39e1",
        "storage_key": "property/6767906449167350/019d63b2-0f92-72ec-b312-d0cf11fb39e1.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://www.richlandcountyoh.gov/departments/RichlandCountParksDistrict",
      "poi_directions_map_url": "https://maps.google.com/?cid=1290097879386109782&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gorman-nature-center",
      "poi_latitude": "40.699768",
      "poi_longitude": "-82.5563221",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-884-3764",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019dac3e-7519-70f0-be15-a74e51740971",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZytWAzAOYgRVjdLoi9Z5xE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_d6cf293c25f1ef480375b98e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Sterkel Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "790 Hollywood Ln, Mansfield, OH 44907, USA",
      "poi_short_description": "City park featuring a playground, baseball fields, and picnic tables, plus a public restroom.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b1-c0c2-77fa-a3f6-308f3acbf4af.webp",
      "poi_featured_image_media": {
        "alt_text": "Colorful playground with slides, climbing structures, and a train-themed play area.",
        "public_id": "019d63b1-c0c2-77fa-a3f6-308f3acbf4af",
        "storage_key": "property/6767906449167350/019d63b1-c0c2-77fa-a3f6-308f3acbf4af.webp",
        "width": 2048,
        "height": 1536
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1075627809786518065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sterkel-park",
      "poi_latitude": "40.7365726",
      "poi_longitude": "-82.5229737",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 419-522-9801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019dac3e-7519-70f0-be15-a74e51740971",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYaYJvPTqOYgRMVrbSMtl7Q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_29deffefdea2be65b4e894f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Kingwood Center Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "50 N Trimble Rd, Mansfield, OH 44906, USA",
      "poi_short_description": "Former estate grounds spanning 47 acres featuring a variety of formal gardens, with tours available.",
      "poi_long_description": "Former estate grounds spanning 47 acres featuring a variety of formal gardens, with tours available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b1-8800-703e-b319-e05316b77f34.webp",
      "poi_featured_image_media": {
        "alt_text": "Grand brick building with a prominent arched entrance and multiple windows.",
        "public_id": "019d63b1-8800-703e-b319-e05316b77f34",
        "storage_key": "property/6767906449167350/019d63b1-8800-703e-b319-e05316b77f34.webp",
        "width": 2119,
        "height": 1192
      },
      "poi_business_url": "http://www.kingwoodcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1898681523339425512&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kingwood-center-gardens",
      "poi_latitude": "40.760457",
      "poi_longitude": "-82.5515482",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 419-522-0211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN6VwH07rOYgR6HY-LMl4WRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "ec_9e9b26ba9c7f61f449954992",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "South Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Brinkerhoff Ave, Mansfield, OH 44903, USA",
      "poi_short_description": "Relaxed blockhouse and cabin park, also featuring a picnic area, playground and trails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-ccc9-723b-9c85-455d8962c0bf.webp",
      "poi_featured_image_media": {
        "alt_text": "Historic log cabin with a stone chimney and an American flag.",
        "public_id": "019dac40-ccc9-723b-9c85-455d8962c0bf",
        "storage_key": "property/6767906449167350/019dac40-ccc9-723b-9c85-455d8962c0bf.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=18396170489436583766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-park",
      "poi_latitude": "40.7564883",
      "poi_longitude": "-82.54307299999999",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-522-9801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019dac3e-7519-70f0-be15-a74e51740971",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqTDRoN_qOYgRVjdk0pdTTP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1f4e2545733f6dbdd757e3fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Sterkel Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "790 Hollywood Ln, Mansfield, OH 44907, USA",
      "poi_short_description": "City park featuring a playground, baseball fields, and picnic tables, plus a public restroom.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b1-c0c2-77fa-a3f6-308f3acbf4af.webp",
      "poi_featured_image_media": {
        "alt_text": "Colorful playground with slides, climbing structures, and a train-themed play area.",
        "public_id": "019d63b1-c0c2-77fa-a3f6-308f3acbf4af",
        "storage_key": "property/6767906449167350/019d63b1-c0c2-77fa-a3f6-308f3acbf4af.webp",
        "width": 2048,
        "height": 1536
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=1075627809786518065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sterkel-park",
      "poi_latitude": "40.7365726",
      "poi_longitude": "-82.5229737",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 419-522-9801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019dac3e-7519-70f0-be15-a74e51740971",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYaYJvPTqOYgRMVrbSMtl7Q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "ec_8d9edf403d7cf8e88b041d5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Ontario Marshall Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "44906, 3375 Milligan Rd, Ontario, OH 44906, USA",
      "poi_short_description": "Local park with a playground, pavilions & picnic areas popular for football, baseball & concerts.",
      "poi_long_description": "Local park with a playground, pavilions & picnic areas popular for football, baseball & concerts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-dd44-723a-8b18-e2caa28cb3ea.webp",
      "poi_featured_image_media": {
        "alt_text": "Children playing soccer on a grassy field with goals and trees in the background.",
        "public_id": "019dbbf0-dd44-723a-8b18-e2caa28cb3ea",
        "storage_key": "property/6767906449167350/019dbbf0-dd44-723a-8b18-e2caa28cb3ea.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://m.facebook.com/pages/Marshall-Park/186931301352696",
      "poi_directions_map_url": "https://maps.google.com/?cid=9838539912740751369&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ontario-marshall-park",
      "poi_latitude": "40.7672689",
      "poi_longitude": "-82.6341636",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 419-529-3818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019dac3e-7519-70f0-be15-a74e51740971",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJE2JdPzOUOYgRCUhqf-yDiYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_8dfb7e88848ede354d0f355a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Maize Memorial Dog Park, llc",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3201-3311 Milligan Rd, Ontario, OH 44906, USA",
      "poi_short_description": "Recreational area providing short trails, a playground, and separate spaces for dogs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-e127-772f-bbec-36843dd8c9b2.webp",
      "poi_featured_image_media": {
        "alt_text": "Two dogs in a fenced-in grassy area.",
        "public_id": "019dbbf0-e127-772f-bbec-36843dd8c9b2",
        "storage_key": "property/6767906449167350/019dbbf0-e127-772f-bbec-36843dd8c9b2.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13713904890849966160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maize-memorial-dog-park-llc",
      "poi_latitude": "40.7642344",
      "poi_longitude": "-82.6408898",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
      "poi_map_icon_media": {
        "alt_text": "Stylized black tree icon",
        "public_id": "019dac3e-7519-70f0-be15-a74e51740971",
        "storage_key": "property/6767906449167350/019dac3e-7519-70f0-be15-a74e51740971.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoeXUSjKUOYgRULiavtaTUb4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "ec_f61cbc32eb89513c39c0c661",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Stanton Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "74 S Diamond St, Mansfield, OH 44902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-dee5-77fa-b35c-8a77d706c1a2.webp",
      "poi_featured_image_media": {
        "alt_text": "Waiting area with blue chairs and a closed 'Transit Cafe' counter.",
        "public_id": "019dac40-dee5-77fa-b35c-8a77d706c1a2",
        "storage_key": "property/6767906449167350/019dac40-dee5-77fa-b35c-8a77d706c1a2.webp",
        "width": 1382,
        "height": 3072
      },
      "poi_business_url": "http://www.rctbuses.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15812628083074238857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stanton-transit-center",
      "poi_latitude": "40.7563863",
      "poi_longitude": "-82.5145521",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 567-560-5871",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YtotVTqOYgRiYkBcXa9cds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_e5a8fbcb4a12e76a6197bc9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Richland County Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "232 N Main St, Mansfield, OH 44902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.rctbuses.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14031334901183504434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richland-county-transit",
      "poi_latitude": "40.7644186",
      "poi_longitude": "-82.5148835",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 419-522-4504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm-Pu76jrOYgRMmCVXcBQucI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "ec_a363b4ebbdc3039116b85226",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Mansfield Lahm Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2000 Harrington Memorial Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-3dba-7459-be6d-13abee62b4fc.webp",
      "poi_featured_image_media": {
        "alt_text": "A crowd of people gathered to watch a NASA Super Guppy airplane being unloaded.",
        "public_id": "019d63b2-3dba-7459-be6d-13abee62b4fc",
        "storage_key": "property/6767906449167350/019d63b2-3dba-7459-be6d-13abee62b4fc.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://mansfieldlahmairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17095934472027146145&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mansfield-lahm-regional-airport",
      "poi_latitude": "40.8157539",
      "poi_longitude": "-82.5127105",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 419-522-2191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-7a50-776d-a89d-ab6257572007.webp",
      "poi_map_icon_media": {
        "alt_text": "Airplane icon",
        "public_id": "019dac3e-7a50-776d-a89d-ab6257572007",
        "storage_key": "property/6767906449167350/019dac3e-7a50-776d-a89d-ab6257572007.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJcThDKV_sOYgRoYeI_NL1QO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_3cddf5f618f9e47031906300",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Greyhound: Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "2424 Possum Run Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac40-ec0b-71d0-bcfc-e22ebe89924e.webp",
      "poi_featured_image_media": {
        "alt_text": "Young woman with luggage by a bus",
        "public_id": "019dac40-ec0b-71d0-bcfc-e22ebe89924e",
        "storage_key": "property/6767906449167350/019dac40-ec0b-71d0-bcfc-e22ebe89924e.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.greyhound.com/bus/mansfield-oh/mansfield-bus-stop?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=14255621450852221001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-stop",
      "poi_latitude": "40.692915",
      "poi_longitude": "-82.5117873",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSCp9LbBOYgRSUB8Fi4k1sU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_3285bd7c8e4c1af4ad93f47f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Air National Guard Recruiter",
      "poi_type": "Transportation & Transit",
      "poi_address": "1947 Harrington Memorial Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.ang.af.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8622281219083133410&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "air-national-guard-recruiter",
      "poi_latitude": "40.8123932",
      "poi_longitude": "-82.5154448",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 419-520-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac41-017b-75db-8fe7-cb480ad8900d.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019dac41-017b-75db-8fe7-cb480ad8900d",
        "storage_key": "property/6767906449167350/019dac41-017b-75db-8fe7-cb480ad8900d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm092jGPsOYgR4uH4ABZ_qHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_a9edb53ced54a8bb42d8fa18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Eastbound Rest Area - Mansfield",
      "poi_type": "Transportation & Transit",
      "poi_address": "Mansfield, OH 44903, USA",
      "poi_short_description": "Clean pit stop featuring grassy areas, picnic tables, benches and charcoal grills.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dbbf0-e054-772e-a3fd-b7528aa27842.webp",
      "poi_featured_image_media": {
        "alt_text": "Picnic tables in a grassy area with trees in the background.",
        "public_id": "019dbbf0-e054-772e-a3fd-b7528aa27842",
        "storage_key": "property/6767906449167350/019dbbf0-e054-772e-a3fd-b7528aa27842.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2342192191299698683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastbound-rest-area---mansfield",
      "poi_latitude": "40.7797562",
      "poi_longitude": "-82.42011320000002",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdUiiRMXoOYgR-78cdmMjgSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "rest_stop"
    },
    {
      "id": "ec_ff71c42037c8eb6772e51460",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "OhioHealth Mansfield Hospital and Emergency Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "335 Glessner Ave, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b1-6c50-75a9-81fa-e2433c85bf3d.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a modern brick building with an American flag waving in front.",
        "public_id": "019d63b1-6c50-75a9-81fa-e2433c85bf3d",
        "storage_key": "property/6767906449167350/019d63b1-6c50-75a9-81fa-e2433c85bf3d.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.ohiohealth.com/locations/hospitals/mansfield-hospital/?utm_source=yext&utm_medium=listings&utm_campaign=websiteclicksfacility",
      "poi_directions_map_url": "https://maps.google.com/?cid=1107658932139026326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ohiohealth-mansfield-hospital-and-emergency-department",
      "poi_latitude": "40.752648",
      "poi_longitude": "-82.5295987",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 419-526-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f6-73fa-bc42-c1040a72048d.webp",
      "poi_map_icon_media": {
        "alt_text": "Logo of H",
        "public_id": "019dac3e-74f6-73fa-bc42-c1040a72048d",
        "storage_key": "property/6767906449167350/019dac3e-74f6-73fa-bc42-c1040a72048d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyx2imPzqOYgRlmdvHu4xXw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_5a9a3fced13d7a1333f55e4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "The Ohio State University at Mansfield",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1760 University Dr, Mansfield, OH 44906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b8-f080-7761-9a29-f95a7be3d6a2.webp",
      "poi_featured_image_media": {
        "alt_text": "OSU Theatre display case featuring posters of William Shakespeare productions, lit with colorful bulbs.",
        "public_id": "019d63b8-f080-7761-9a29-f95a7be3d6a2",
        "storage_key": "property/6767906449167350/019d63b8-f080-7761-9a29-f95a7be3d6a2.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://mansfield.osu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4049580252666124585&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ohio-state-university-at-mansfield",
      "poi_latitude": "40.7971264",
      "poi_longitude": "-82.5794396",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 419-755-4317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqymbFqGUOYgRKdmZwcj_Mjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_1fe0c5edd4444e3a8b1a21af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "North Central State College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2441 Kenwood Cir, Mansfield, OH 44906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b7-6cfb-72cd-824b-3f5906acd2b4.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern building with the text FALLERIUS CENTER above the entrance.",
        "public_id": "019d63b7-6cfb-72cd-824b-3f5906acd2b4",
        "storage_key": "property/6767906449167350/019d63b7-6cfb-72cd-824b-3f5906acd2b4.webp",
        "width": 1000,
        "height": 664
      },
      "poi_business_url": "http://www.ncstatecollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17001004180715244171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-central-state-college",
      "poi_latitude": "40.79976389999999",
      "poi_longitude": "-82.5818534",
      "poi_miles_from_property": "8.5 mi",
      "poi_walking_minutes": "3 hours 8 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 419-755-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDQFTRqCUOYgRi4p2KDqz7-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_1252760c1f2c6897516c7354",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Gorman-Rupp Pumps",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 S Airport Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63bd-a79d-732e-ad75-a16c78fdc6b4.webp",
      "poi_featured_image_media": {
        "alt_text": "Gorman-Rupp Pumps team photo with 'The Pump People' slogan.",
        "public_id": "019d63bd-a79d-732e-ad75-a16c78fdc6b4",
        "storage_key": "property/6767906449167350/019d63bd-a79d-732e-ad75-a16c78fdc6b4.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.grpumps.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11142363348924561568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gorman-rupp-pumps",
      "poi_latitude": "40.8078921",
      "poi_longitude": "-82.5041809",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 419-755-1011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi-rUy9XtOYgRoPj6Wm6goZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_681c778d5178fcf3b4925801",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Newman Technology, Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Cairns Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63be-8e00-7104-916e-d9739306c69c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d63be-8e00-7104-916e-d9739306c69c",
        "storage_key": "property/6767906449167350/019d63be-8e00-7104-916e-d9739306c69c.webp",
        "width": 1728,
        "height": 3072
      },
      "poi_business_url": "http://www.newmantech.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6600621734690037779&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newman-technology-inc",
      "poi_latitude": "40.8070399",
      "poi_longitude": "-82.5175952",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 419-525-1856",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
      "poi_map_icon_media": {
        "alt_text": "Black circle icon",
        "public_id": "019dac3e-74f5-70fc-8505-9f6d23cb2993",
        "storage_key": "property/6767906449167350/019dac3e-74f5-70fc-8505-9f6d23cb2993.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOSPHs2LsOYgREyDsAH8emls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_e973adf0ba191affed0afee3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Richland County Clerk of Courts",
      "poi_type": "Major Employers & Offices",
      "poi_address": "50 Park Ave E, Mansfield, OH 44902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63bd-5b16-716a-bb95-f75beb06d4c5.webp",
      "poi_featured_image_media": {
        "alt_text": "Richland County Drug Free banner hanging on a brick building with arched windows.",
        "public_id": "019d63bd-5b16-716a-bb95-f75beb06d4c5",
        "storage_key": "property/6767906449167350/019d63bd-5b16-716a-bb95-f75beb06d4c5.webp",
        "width": 761,
        "height": 507
      },
      "poi_business_url": "https://www.richlandcourtsoh.us/clerkHome.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=17636404261965479397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richland-county-clerk-of-courts",
      "poi_latitude": "40.7578139",
      "poi_longitude": "-82.5138915",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 419-774-5540",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac41-017b-75db-8fe7-cb480ad8900d.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019dac41-017b-75db-8fe7-cb480ad8900d",
        "storage_key": "property/6767906449167350/019dac41-017b-75db-8fe7-cb480ad8900d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfcBfZqvrOYgR5T2jDTwYwfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_45f1e34fb3b474fb6241f75a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "City of Mansfield Ohio, Mayors Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "30 N Diamond St, Mansfield, OH 44902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ci.mansfield.oh.us/city-directory/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11023381916364958063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "city-of-mansfield-ohio-mayors-office",
      "poi_latitude": "40.7590012",
      "poi_longitude": "-82.51299709999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 419-755-9626",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac41-017b-75db-8fe7-cb480ad8900d.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019dac41-017b-75db-8fe7-cb480ad8900d",
        "storage_key": "property/6767906449167350/019dac41-017b-75db-8fe7-cb480ad8900d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG0t-m6vrOYgRb-ll1HLr-pg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_e7edd9bf1f2a3ec538bbb753",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Mansfield Correctional Institution",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1150 N Main St, Mansfield, OH 44902, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.drc.ohio.gov/manci",
      "poi_directions_map_url": "https://maps.google.com/?cid=9304039268351510120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mansfield-correctional-institution",
      "poi_latitude": "40.7915083",
      "poi_longitude": "-82.5117349",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-525-4455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac41-017b-75db-8fe7-cb480ad8900d.webp",
      "poi_map_icon_media": {
        "alt_text": "Building icon",
        "public_id": "019dac41-017b-75db-8fe7-cb480ad8900d",
        "storage_key": "property/6767906449167350/019dac41-017b-75db-8fe7-cb480ad8900d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdLmn4brOYgRaIZgbmuWHoE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "ec_394965f8cf6a0cbde8ef8ed3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Avita Health System - Ontario Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "715 Richland Mall, Ontario, OH 44906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-4522-76a9-ad58-aee4f6760962.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Avita Ontario Hospital with a large parking lot in the foreground.",
        "public_id": "019dac3e-4522-76a9-ad58-aee4f6760962",
        "storage_key": "property/6767906449167350/019dac3e-4522-76a9-ad58-aee4f6760962.webp",
        "width": 2667,
        "height": 1500
      },
      "poi_business_url": "https://avitahealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1017345531180711074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "avita-health-system---ontario-hospital",
      "poi_latitude": "40.7716066",
      "poi_longitude": "-82.5935463",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 567-307-7557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74f6-73fa-bc42-c1040a72048d.webp",
      "poi_map_icon_media": {
        "alt_text": "Logo of H",
        "public_id": "019dac3e-74f6-73fa-bc42-c1040a72048d",
        "storage_key": "property/6767906449167350/019dac3e-74f6-73fa-bc42-c1040a72048d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8t95UaUOYgRonzb115WHg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "ec_9b0d4467fe58d2937949f795",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "generator",
      "poi_name": "Mansfield Senior High School",
      "poi_type": "Major Employers & Offices",
      "poi_address": "124 N Linden Rd, Mansfield, OH 44903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b8-2380-7084-9266-68ee3cc942ef.webp",
      "poi_featured_image_media": {
        "alt_text": "Aerial view of a large sports complex with arched roof structures and surrounding parking lots and green spaces.",
        "public_id": "019d63b8-2380-7084-9266-68ee3cc942ef",
        "storage_key": "property/6767906449167350/019d63b8-2380-7084-9266-68ee3cc942ef.webp",
        "width": 2048,
        "height": 1151
      },
      "poi_business_url": "https://www.tygerpride.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10688980534084341018&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mansfield-senior-high-school",
      "poi_latitude": "40.7622345",
      "poi_longitude": "-82.54347279999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 419-525-6369",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
      "poi_map_icon_media": {
        "alt_text": "Graduation cap icon",
        "public_id": "019dac3e-74ea-729b-b537-ecc03dfaffac",
        "storage_key": "property/6767906449167350/019dac3e-74ea-729b-b537-ecc03dfaffac.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJU6CH1CPrOYgRGo0pwSnjVpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    }
  ],
  "office_hours": [
    {
      "id": "custom_a9f97b1c-c022-449f-9445-ff28139f7f8e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_f0469e4a-1c40-4308-92a5-7f7a7c185d9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_eada1d52-e6a1-4060-b3a4-6e672eaf23b5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "day": "TUE",
      "open_time": "08:00",
      "close_time": "16:00"
    },
    {
      "id": "custom_4170da8f-b04e-4b1e-a35c-08068715165f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "day": "WED",
      "open_time": "08:00",
      "close_time": "16:00"
    },
    {
      "id": "custom_84bdb099-dcfd-4049-8259-63adf4dfe35d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "day": "FRI",
      "open_time": "08:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_b935f254-dc1f-4ee7-ad51-d84435181fe6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "rating": "5.0",
      "name": "Rebecca Harris",
      "text": "Nice place. Pretty well maintained. Locked building is nice. Only complaint would be that people leave laundry in washers and dryers over night and all day. That's inconsiderate. Could also maybe use another handicap parking spot for each building instead of just one.",
      "date": "2023-03-20",
      "title": ""
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019e1ddc-6a4e-70cb-b627-1addbf8a087b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "cwa---cedarwood-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350"
    },
    {
      "lead_collector_id": "019e1ddc-6ac7-7719-8533-ec7555878fae",
      "lead_source": "FACEBOOK_ADS",
      "name": "cwa---cedarwood-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350"
    },
    {
      "lead_collector_id": "019e1ddc-6b3a-719f-ba80-46fb3e53b912",
      "lead_source": "LANDING_PAGE",
      "name": "cwa---cedarwood-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-mansfield-oh",
      "search_query": "pet friendly apartments mansfield oh",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Mansfield, OH",
      "h2_subtitle": "Explore pet-friendly living at Cedar Wood Apartments. Our Mansfield, OH community welcomes your furry friends with open arms and great amenities.",
      "page_copy": "Discover pet-friendly apartment living at Cedar Wood Apartments in Mansfield, OH. Our spacious two- and three-bedroom floor plans feature comfortable layouts, modern conveniences, and pet-friendly policies designed to support a variety of household needs.\n\nLocated in Mansfield, OH, Cedar Wood Apartments offers convenient access to local amenities and everyday conveniences. Residents benefit from flexible rent payment options, professional management services, and central heating and air conditioning for year-round comfort. Learn more about our pet-friendly apartment homes and community amenities at Cedar Wood Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Mansfield, OH",
      "seo_description": "Find pet friendly apartments in Mansfield, OH at Cedar Wood Apartments. Enjoy spacious floor plans and great amenities! Schedule a visit today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "apartments-professional-management-richland-county",
      "search_query": "apartments with professional management richland county",
      "category": "Amenity",
      "h1_title": "Apartments with Professional Management",
      "h2_subtitle": "Discover top-notch living at Cedar Wood Apartments in Richland County. Our professional management team ensures a seamless living experience.",
      "page_copy": "Cedar Wood Apartments in Richland County offers professional management services designed to support residents throughout their tenancy. Our on-site management team is available to assist with community-related needs and help maintain a well-managed residential environment.\n\nLocated in Mansfield, OH, our apartment community features professionally managed apartment homes with modern conveniences. Residents benefit from responsive management services while taking advantage of the community amenities available. Learn more about the professional management and residential opportunities available at Cedar Wood Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Professional Management",
      "seo_description": "Discover professionally managed apartments in Richland County at Cedar Wood Apartments. Enjoy seamless living with our dedicated management team.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "flexible-rent-payment-options-mansfield-ohio",
      "search_query": "flexible rent payment options mansfield ohio",
      "category": "Amenity",
      "h1_title": "Flexible Rent Payment Options in Mansfield",
      "h2_subtitle": "Cedar Wood Apartments offers flexible rent payment options in Mansfield, Ohio, making it easy to find a home tailored to your financial needs.",
      "page_copy": "Cedar Wood Apartments in Mansfield, Ohio, offers flexible rent payment options to provide additional convenience for residents. Our community features services and amenities designed to support everyday apartment living, including payment solutions that offer added flexibility.\n\nLocated in Mansfield, Ohio, our spacious apartment homes include amenities such as central heating and air conditioning for year-round comfort. Residents can also enjoy professional management services and other community features designed to support comfortable apartment living. Learn more about the flexible payment options and amenities available at Cedar Wood Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Flexible Rent Payment Options in Mansfield",
      "seo_description": "Cedar Wood Apartments in Mansfield, Ohio offers flexible rent payment plans. Enjoy financial ease while living in comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "central-heat-air-conditioning-richland",
      "search_query": "central heat and air conditioning richland",
      "category": "Amenity",
      "h1_title": "Central Heat & Air in Richland Apartments",
      "h2_subtitle": "Experience ultimate comfort with central heat and air conditioning at Cedar Wood Apartments, conveniently located in Richland County.",
      "page_copy": "Cedar Wood Apartments in Richland County offers spacious two- and three-bedroom apartment homes with central heating and air conditioning for year-round temperature control. These features help provide a comfortable indoor environment throughout the seasons.\n\nLocated in Mansfield, OH, our community offers a variety of amenities and services, including professional management, pet-friendly policies, and flexible rent payment options. Residents can enjoy apartment features and community amenities designed to support everyday living. Learn more about what Cedar Wood Apartments has to offer in Richland County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Richland Apartments with Central Heat & Air",
      "seo_description": "Enjoy central heat and air conditioning at Cedar Wood Apartments in Richland County. Experience ultimate comfort and convenience in modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "ideal-location-apartments-44903",
      "search_query": "ideal location apartments 44903",
      "category": "Amenity",
      "h1_title": "Ideal Location Apartments in 44903",
      "h2_subtitle": "Discover the perfect living spot in Mansfield, OH with our apartments situated in the ideal location, 44903. Cedar Wood Apartments is your new home base.",
      "page_copy": "Located in Mansfield, OH, Cedar Wood Apartments is conveniently situated in the 44903 ZIP code. Our community provides convenient access to local shopping, dining, entertainment, and everyday services, making it easy to enjoy everything the area has to offer.\n\nCedar Wood Apartments features spacious two- and three-bedroom floor plans with functional layouts and modern conveniences. Residents benefit from a pet-friendly community, professional management services, and flexible rent payment options. Learn more about the apartment homes and community amenities available at Cedar Wood Apartments in Mansfield.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ideal Location Apartments in Mansfield, 44903",
      "seo_description": "Cedar Wood Apartments offer the ideal location in the 44903 area. Enjoy modern living with convenient access to all Mansfield has to offer.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-mansfield-oh",
      "search_query": "two bedroom apartments Mansfield OH",
      "category": "Floorplan",
      "h1_title": "Spacious Two-Bedroom Apartments in Mansfield",
      "h2_subtitle": "Explore the welcoming two-bedroom apartments at Cedar Wood in Mansfield, OH. Experience comfort, style, and convenience.",
      "page_copy": "Nestled in the charming city of Mansfield, OH, Cedar Wood Apartments provides spacious two-bedroom homes that cater to your lifestyle needs. These modern layouts are perfect for those seeking a comfortable and stylish living environment, complete with essential amenities for convenience and peace of mind.\n\nOur two-bedroom apartments feature central heating and air conditioning, ensuring a cozy home in every season. Cedar Wood Apartments offer a range of resident benefits, including flexible rent payment options, professional management, and a pet-friendly policy. Discover how our community combines the best of Mansfield living with the comfort and style of our two-bedroom options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Two-Bedroom Apartments in Mansfield",
      "seo_description": "Discover two-bedroom apartments in Mansfield, OH at Cedar Wood. Enjoy modern living with central air, flexible payments, and more.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "three-bedroom-floor-plans-richland-county",
      "search_query": "three bedroom floor plans Richland County",
      "category": "Floorplan",
      "h1_title": "Three-Bedroom Floor Plans in Richland",
      "h2_subtitle": "Discover spacious three-bedroom floor plans at Cedar Wood Apartments in Richland County, designed for modern living and ultimate comfort.",
      "page_copy": "Cedar Wood Apartments in Richland County offers expansive three-bedroom apartment homes with functional layouts and modern conveniences. These thoughtfully designed floor plans provide additional living space and flexibility for a variety of household needs. Each apartment includes central heating and air conditioning for year-round temperature control.\n\nLocated in Mansfield, our community offers a residential setting with convenient access to local amenities and services. Residents benefit from professional management, flexible rent payment options, and a pet-friendly community. Explore the three-bedroom apartment homes and community amenities available at Cedar Wood Apartments in Richland County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three-Bedroom Floor Plans in Richland",
      "seo_description": "Explore Cedar Wood Apartments' three-bedroom floor plans in Richland County. Modern living with central air and pet-friendly options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "apartments-near-madison-south-elementary-oh",
      "search_query": "apartments near Madison South Elementary School OH",
      "category": "School",
      "h1_title": "Apartments Near Madison South Elementary",
      "h2_subtitle": "Discover family-friendly living at Cedar Wood Apartments, ideally located near Madison South Elementary School in OH for convenient education access.",
      "page_copy": "Cedar Wood Apartments is conveniently located near Madison South Elementary School in Mansfield, OH. Our community offers spacious two- and three-bedroom floor plans with modern conveniences and easy access to nearby schools, shopping, dining, and other local amenities.\n\nOur pet-friendly apartments feature central heating and air conditioning for year-round comfort. Residents also benefit from professional management services and flexible rent payment options. Cedar Wood Apartments offers convenient access to local destinations while providing a variety of apartment features and community amenities in Mansfield, OH.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Madison South Elementary OH",
      "seo_description": "Find spacious apartments near Madison South Elementary School in OH at Cedar Wood. Enjoy pet-friendly living with convenient school access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "apartments-close-mifflin-elementary-richland-county",
      "search_query": "apartments close to Mifflin Elementary School Richland County",
      "category": "School",
      "h1_title": "Apartments Near Mifflin Elementary School",
      "h2_subtitle": "Live close to Mifflin Elementary School at Cedar Wood Apartments, offering comfort and convenience in Richland County.",
      "page_copy": "Cedar Wood Apartments, located in Richland County, offers convenient access to Mifflin Elementary School and other local destinations. Our spacious two- and three-bedroom floor plans provide flexible living space and modern apartment features designed to support a variety of household needs.\n\nCommunity amenities include central heating and air conditioning, a pet-friendly policy, flexible rent payment options, and professional management services. Cedar Wood Apartments also provides convenient access to shopping, dining, schools, and other local amenities throughout the Mansfield area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mifflin Elementary School",
      "seo_description": "Discover apartments close to Mifflin Elementary School in Richland County at Cedar Wood. ",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "cedar-wood-apartments-eastview-elementary",
      "search_query": "Cedar Wood Apartments near Eastview Elementary School",
      "category": "School",
      "h1_title": "Cedar Wood Apartments Near Eastview Elementary",
      "h2_subtitle": "Enjoy life at Cedar Wood Apartments, conveniently located near Eastview Elementary School, offering fantastic amenities and community features.",
      "page_copy": "Cedar Wood Apartments in Mansfield, OH offers a convenient residential location near Eastview Elementary School. Our spacious two- and three-bedroom floor plans feature functional layouts and modern conveniences, including central heating and air conditioning for year-round temperature control.\n\nResidents benefit from a pet-friendly community, flexible rent payment options, and professional management services. In addition to convenient access to Eastview Elementary School, the community is located near shopping, dining, recreational opportunities, and other local amenities throughout the Mansfield area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Wood Apts Near Eastview Elementary",
      "seo_description": "Cedar Wood Apartments near Eastview Elementary School offer convenient living in Mansfield, OH, with modern amenities and friendly management.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "apartments-by-madison-middle-school-mansfield",
      "search_query": "apartments by Madison Middle School Mansfield",
      "category": "School",
      "h1_title": "Apartments Near Madison Middle School",
      "h2_subtitle": "Discover Cedar Wood Apartments in Mansfield, conveniently located by Madison Middle School, offering spacious and comfortable living options.",
      "page_copy": "Cedar Wood Apartments is conveniently located in Mansfield, OH, just minutes from Madison Middle School. Our community offers spacious two- and three-bedroom floor plans featuring functional layouts and modern conveniences.\n\nResidents enjoy amenities such as central heating and air conditioning for year-round temperature control, along with a pet-friendly community, flexible rent payment options, and professional management services. In addition to its proximity to Madison Middle School, Cedar Wood Apartments offers convenient access to shopping, dining, entertainment, and other local amenities throughout Mansfield.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Madison Middle School Mansfield",
      "seo_description": "Explore Cedar Wood Apartments near Madison Middle School in Mansfield, offering pet-friendly living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "rentals-near-madison-high-school-llc-mansfield",
      "search_query": "rentals near Madison High School LLC Mansfield",
      "category": "School",
      "h1_title": "Rentals Near Madison High School in Mansfield",
      "h2_subtitle": "Enjoy the convenience of Cedar Wood Apartments, located near Madison High School LLC in Mansfield, featuring modern amenities and pet-friendly living.",
      "page_copy": "Cedar Wood Apartments offers a convenient location near Madison High School in Mansfield, OH. Our community features spacious two- and three-bedroom floor plans with functional layouts and modern conveniences.\n\nApartment amenities include central heating and air conditioning, a pet-friendly policy, flexible rent payment options, and professional management services. Residents also benefit from convenient access to Madison High School, shopping, dining, and other local amenities throughout Mansfield.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Madison High School LLC Mansfield",
      "seo_description": "Find rentals at Cedar Wood Apartments near Madison High School LLC in Mansfield, offering spacious living and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "malabar-intermediate-school-nearby-apartments",
      "search_query": "Malabar Intermediate School nearby apartments Mansfield",
      "category": "School",
      "h1_title": "Apartments Near Malabar Intermediate School",
      "h2_subtitle": "Explore Cedar Wood Apartments, located near Malabar Intermediate School in Mansfield, offering spacious floor plans and convenient amenities.",
      "page_copy": "Situated in Mansfield, OH, Cedar Wood Apartments offers a convenient location near Malabar Intermediate School. Our community features spacious two- and three-bedroom floor plans with functional layouts and modern conveniences, located close to schools, shopping, dining, and other local amenities.\n\nCedar Wood Apartments offers a pet-friendly community, professional management services, central heating and air conditioning for year-round temperature control, and flexible rent payment options. Residents benefit from convenient access to local services and community amenities throughout the Mansfield area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Malabar Intermediate School",
      "seo_description": "Discover Cedar Wood Apartments near Malabar Intermediate School in Mansfield, offering spacious rentals with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "apartments-surrounding-discovery-school-mansfield",
      "search_query": "apartments surrounding DISCOVERY SCHOOL Mansfield",
      "category": "School",
      "h1_title": "Apartments Around Discovery School",
      "h2_subtitle": "Find Cedar Wood Apartments surrounding Discovery School in Mansfield, offering spacious layouts and comfortable living options.",
      "page_copy": "Cedar Wood Apartments offers a convenient residential location near Discovery School in Mansfield, OH. Our community features spacious two- and three-bedroom floor plans with functional layouts and modern conveniences.\n\nResidents benefit from a pet-friendly community, flexible rent payment options, professional management services, and central heating and air conditioning for year-round temperature control. Cedar Wood Apartments also provides convenient access to nearby schools, shopping, dining, and other local amenities throughout the Mansfield area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Surrounding Discovery School Mansfield",
      "seo_description": "Explore Cedar Wood Apartments near Discovery School in Mansfield, offering convenient living with spacious layouts and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "apartments-near-ohio-state-university-mansfield",
      "search_query": "apartments near The Ohio State University at Mansfield",
      "category": "School",
      "h1_title": "Apartments Near Ohio State University Mansfield",
      "h2_subtitle": "Discover Cedar Wood Apartments close to The Ohio State University at Mansfield. Enjoy spacious living and a welcoming community.",
      "page_copy": "Located in Mansfield, OH, Cedar Wood Apartments is conveniently situated near The Ohio State University at Mansfield. Our community offers spacious two- and three-bedroom floor plans featuring functional layouts and modern conveniences, all within easy reach of campus and surrounding amenities.\n\nCommunity features include a pet-friendly policy, flexible rent payment options, central heating and air conditioning for year-round temperature control, and professional management services. Residents also benefit from convenient access to The Ohio State University at Mansfield, nearby employment centers, shopping, dining, and other local amenities throughout the area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ohio State University Mansfield",
      "seo_description": "Cedar Wood Apartments offers convenient living near The Ohio State University at Mansfield with spacious layouts and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "apartments-near-ohiohealth-mansfield-hospital",
      "search_query": "apartments near OhioHealth Mansfield Hospital OH",
      "category": "Hospital",
      "h1_title": "Apartments Near OhioHealth Mansfield Hospital",
      "h2_subtitle": "Explore Cedar Wood Apartments, conveniently located near OhioHealth Mansfield Hospital, providing comfortable and modern living options.",
      "page_copy": "Cedar Wood Apartments offers a convenient residential location near OhioHealth Mansfield Hospital in Mansfield, OH. Our community features spacious two- and three-bedroom floor plans with functional layouts and modern conveniences, all within easy reach of nearby services and destinations.\n\nCommunity amenities include a pet-friendly policy, flexible rent payment options, professional management services, and central heating and air conditioning for year-round temperature control. Residents also benefit from convenient access to OhioHealth Mansfield Hospital, shopping, dining, and other local amenities throughout the Mansfield area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near OhioHealth Mansfield Hospital",
      "seo_description": "Find your home at Cedar Wood Apartments close to OhioHealth Mansfield Hospital, offering comfortable living and modern conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "apartments-near-maple-lake-park-mansfield",
      "search_query": "apartments near Maple Lake Park Mansfield",
      "category": "Park",
      "h1_title": "Apartments Near Maple Lake Park, Mansfield",
      "h2_subtitle": "Live close to nature at Cedar Wood Apartments, located near Maple Lake Park in Mansfield. Enjoy spacious and comfortable living spaces.",
      "page_copy": "For those seeking a serene living environment, Cedar Wood Apartments stands as an attractive choice among apartments near Maple Lake Park, Mansfield. Our community provides the perfect balance of tranquility and convenience, offering expansive two and three-bedroom floor plans ideal for modern lifestyles.\n\nEmbrace the perks of pet-friendly living, flexible rent options, and professional management, all while benefiting from central heat and air conditioning. Situated near the scenic Maple Lake Park, Cedar Wood Apartments offers easy access to outdoor recreation and peaceful surroundings, making it a perfect home for nature enthusiasts or those just looking to unwind after a busy day.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Maple Lake Park, Mansfield",
      "seo_description": "Discover Cedar Wood Apartments near Maple Lake Park, Mansfield, offering a peaceful living experience with spacious floor plans and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "living-close-north-lake-park-oh",
      "search_query": "living close to North Lake Park OH",
      "category": "Park",
      "h1_title": "Living Close to North Lake Park, OH",
      "h2_subtitle": "Cedar Wood Apartments offers a unique lifestyle, living close to North Lake Park, OH. Enjoy a peaceful blend of nature and comfort.",
      "page_copy": "Experience the best of both worlds at Cedar Wood Apartments, where living close to North Lake Park, OH, means embracing tranquility while still enjoying modern conveniences. These spacious two and three-bedroom floor plans are tailored for those who appreciate both comfort and the beauty of nearby landscapes.\n\nResidents at Cedar Wood benefit from pet-friendly policies, flexible rent payments, and the assurance of professional management. With central heating and air conditioning, our community ensures year-round comfort. Proximity to North Lake Park provides opportunities for recreation and relaxation, making this an ideal spot for those looking to enjoy the outdoors without compromising on the comforts of home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to North Lake Park, OH",
      "seo_description": "Discover Cedar Wood Apartments, offering modern living close to North Lake Park, OH, with spacious floor plans and serene surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "fleming-falls-preserve-apartments-richland-county",
      "search_query": "Fleming Falls Preserve apartments Richland County",
      "category": "Park",
      "h1_title": "Fleming Falls Preserve Apartments",
      "h2_subtitle": "Discover Cedar Wood Apartments, ideally located near Fleming Falls Preserve in Richland County. Enjoy modern living with scenic views.",
      "page_copy": "Cedar Wood Apartments presents a unique living experience for those seeking Fleming Falls Preserve apartments in Richland County. Nestled in a location that offers both convenience and natural beauty, our community is perfect for those who love exploring the outdoors while enjoying a comfortable home life.\n\nFeaturing expansive two and three-bedroom floor plans, Cedar Wood Apartments delivers modern amenities like flexible rent payments and professional management. Our pet-friendly community and central heating and air conditioning ensure a welcoming atmosphere all year round. Situated near the serene surroundings of Fleming Falls Preserve, it's an ideal choice for nature lovers and anyone seeking a peaceful place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fleming Falls Preserve Apartments",
      "seo_description": "Live near Fleming Falls Preserve in Richland County at Cedar Wood Apartments, offering modern living and scenic beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "gorman-nature-center-rentals-mansfield-area",
      "search_query": "Gorman Nature Center rentals Mansfield area",
      "category": "Park",
      "h1_title": "Gorman Nature Center Rentals Available",
      "h2_subtitle": "Cedar Wood Apartments offers convenient rentals near Gorman Nature Center in the Mansfield area. Experience natural beauty and modern comfort.",
      "page_copy": "For those seeking rentals near Gorman Nature Center in the Mansfield area, Cedar Wood Apartments provides an ideal solution. With our spacious two and three-bedroom floor plans, you can enjoy a harmonious blend of modern amenities and proximity to natural attractions.\n\nOur community is pet-friendly and offers flexible rent payment options, making it easy to enjoy all that Richland County has to offer. Central heating and air conditioning ensure year-round comfort, while professional management caters to all resident needs. Located near the beautiful Gorman Nature Center, Cedar Wood Apartments invites you to experience a refreshing and balanced lifestyle surrounded by nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Gorman Nature Center Rentals Available",
      "seo_description": "Explore rentals near Gorman Nature Center in the Mansfield area at Cedar Wood Apartments, offering modern living with natural charm.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "kingwood-center-gardens-nearby-apartments-44903",
      "search_query": "Kingwood Center Gardens nearby apartments 44903",
      "category": "Park",
      "h1_title": "Apartments Near Kingwood Center Gardens",
      "h2_subtitle": "Find your home at Cedar Wood Apartments, located nearby Kingwood Center Gardens in the 44903 area. Enjoy lush gardens and modern amenities.",
      "page_copy": "Looking for nearby apartments in the 44903 area that offer both comfort and proximity to Kingwood Center Gardens? Cedar Wood Apartments provides an exceptional living experience with expansive two- and three-bedroom floor plans designed for modern living.\n\nOur community features central heating and air conditioning, professional management, and flexible rent payment options. We also offer a pet-friendly environment for residents and their pets. With Kingwood Center Gardens just a short distance away, residents can enjoy convenient access to beautiful outdoor spaces and local attractions while experiencing the benefits of apartment living in Mansfield, OH.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kingwood Center Gardens",
      "seo_description": "Live near Kingwood Center Gardens in the 44903 area at Cedar Wood Apartments, offering modern amenities and beautiful surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "apartments-by-south-park-mansfield-oh",
      "search_query": "apartments by South Park Mansfield OH",
      "category": "Park",
      "h1_title": "Apartments Near South Park Mansfield",
      "h2_subtitle": "Explore Cedar Wood Apartments, conveniently located by South Park Mansfield, OH. Enjoy the blend of nature and modern living.",
      "page_copy": "Cedar Wood Apartments offers an excellent choice for those seeking apartments near South Park in Mansfield, OH. Our spacious two- and three-bedroom floor plans provide a comfortable setting for modern living, while the nearby park offers convenient access to abundant green spaces and outdoor recreation opportunities.\n\nOur community features a pet-friendly environment, professional management, central heating and air conditioning, and flexible rent payment options. Residents can enjoy easy access to local parks and attractions while experiencing the benefits of apartment living in Mansfield, OH.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near South Park Mansfield",
      "seo_description": "Discover Cedar Wood Apartments near South Park in Mansfield, OH, offering spacious living and modern amenities for a perfect community feel.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "ontario-marshall-park-apartments-mansfield-vicinity",
      "search_query": "Ontario Marshall Park apartments Mansfield vicinity",
      "category": "Park",
      "h1_title": "Apartments Near Ontario Marshall Park",
      "h2_subtitle": "Cedar Wood Apartments are conveniently located near Ontario Marshall Park in the Mansfield vicinity. Enjoy the best of both worlds.",
      "page_copy": "Nestled in the Mansfield vicinity, Cedar Wood Apartments offers modern apartment living with convenient access to Ontario Marshall Park. Our spacious two- and three-bedroom layouts are designed to accommodate a variety of living arrangements and household needs while providing easy access to nearby parks and recreational amenities.\n\nResidents enjoy central heating and air conditioning, professional management services, flexible rent payment options, and a pet-friendly community. With Ontario Marshall Park nearby, residents have convenient access to outdoor recreation and green space while enjoying the benefits of apartment living in Mansfield, OH.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Ontario Marshall Park",
      "seo_description": "Live near Ontario Marshall Park in the Mansfield vicinity at Cedar Wood Apartments, where comfort meets nature-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162458",
      "property_id": "6767906449167350",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-near-maize-memorial-dog-park",
      "search_query": "pet-friendly apartments near Maize Memorial Dog Park",
      "category": "Park",
      "h1_title": "Pet-Friendly Apartments Near Maize Dog Park",
      "h2_subtitle": "Discover Cedar Wood Apartments, located near Maize Memorial Dog Park. Perfect for pet lovers seeking a welcoming community.",
      "page_copy": "Cedar Wood Apartments is a pet-friendly apartment community conveniently located near Maize Memorial Dog Park. Offering spacious two- and three-bedroom apartment homes, our community provides pet-friendly features and easy access to nearby outdoor amenities.\n\nResidents enjoy modern conveniences, including central heating and air conditioning, flexible rent payment options, and professional management services. Our pet-friendly policies accommodate residents with pets, while the nearby Maize Memorial Dog Park offers convenient access to outdoor recreation and pet-friendly space. Cedar Wood Apartments combines comfortable apartment living with access to local amenities in Mansfield, OH.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lots and scattered snow.",
        "public_id": "019d63b2-4a4b-71a6-9fa4-88e3486bc473",
        "storage_key": "property/6767906449167350/019d63b2-4a4b-71a6-9fa4-88e3486bc473.webp",
        "width": 2047,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Near Maize Dog Park",
      "seo_description": "Find your new home at Cedar Wood Apartments, pet-friendly and located near Maize Memorial Dog Park, perfect for you and your furry friends.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6189"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11680139400"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5098666"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T6V6D4LM"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_realpage_tour_widget",
      "type": "STRING",
      "value": "<script src=\"https://cs-cdn.realpage.com/CAL/v1.0/cs-calendar-widget.min.js\"></script> <script>var calendar = new csCalendar(\"608396664212\")</script>"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlJEQTlpU2FRTGlTYVZuU1Q0LzVIYkE9PSIsInZhbHVlIjoiZGV3T0QxMnJtUm5obkdvcVRaNi9GQT09IiwibWFjIjoiYTVkNjYxZmU3ZjcxNzkyMGZiMTNhMGRmZWMyYmJjMzhkOTcwM2VhNmI1ZmVhYjBhMDhhYTAxNDRlMmJmNzRiNyJ9"
    }
  ],
  "custom_qb_id": "6189",
  "custom_repli_id": "11680139400",
  "custom_realpage_id": "5098666",
  "custom_google_gtm_id": "GTM-T6V6D4LM",
  "custom_rollout_phase": "Phase 2",
  "custom_vibesites_theme": "Prestige",
  "custom_realpage_tour_widget": "<script src=\"https://cs-cdn.realpage.com/CAL/v1.0/cs-calendar-widget.min.js\"></script> <script>var calendar = new csCalendar(\"608396664212\")</script>",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlJEQTlpU2FRTGlTYVZuU1Q0LzVIYkE9PSIsInZhbHVlIjoiZGV3T0QxMnJtUm5obkdvcVRaNi9GQT09IiwibWFjIjoiYTVkNjYxZmU3ZjcxNzkyMGZiMTNhMGRmZWMyYmJjMzhkOTcwM2VhNmI1ZmVhYjBhMDhhYTAxNDRlMmJmNzRiNyJ9",
  "custom_audioeye_site_id": "f5da7fcb-e202-4491-8c43-7b044a744e27",
  "custom_audioeye_site_hash": "166c299dc9b85951768cac8ad4a85f49"
};

export const generatedAt = '2026-09-23T21:52:07.647Z';
